(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ScribbleLive"] = factory();
	else
		root["ScribbleLive"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VERSION = undefined;
	
	var _package = __webpack_require__(1);
	
	var _package2 = _interopRequireDefault(_package);
	
	var _scribblelive = __webpack_require__(2);
	
	var _constants = __webpack_require__(4);
	
	var _widget = __webpack_require__(5);
	
	var _widget2 = _interopRequireDefault(_widget);
	
	var _content = __webpack_require__(6);
	
	var _content2 = _interopRequireDefault(_content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _Voonto = Voonto,
	    $ = _Voonto.$;
	
	
	Voonto.ready.then(function (app) {
	  _init(app);
	  app.on('voonto:reload', function (event, context$) {
	    return _init(app, context$);
	  });
	});
	
	var VERSION = exports.VERSION = _package2.default.version;
	
	/* Private */
	
	function _init(app, context$) {
	  $('[data-voc-scribblelive]', context$).each(function () {
	    var container$,
	        id,
	        options = {},
	        template,
	        site,
	        editions,
	        hits,
	        url,
	        page;
	
	    container$ = $(this);
	    id = container$.attr('id') || 'sl-' + (window.performance ? window.performance.now() : Date.now());
	    container$.attr('id', id);
	
	    template = _widget2.default;
	    if (container$.data('voc-scribblelive-template')) {
	      template = _content2.default;
	    }
	
	    hits = _constants.DEFAULTS.SL_valor_numeroMensajesPagina;
	    if ($(container$).data('voc-scribblelive-hits')) {
	      hits = $(container$).data('voc-scribblelive-hits');
	    }
	
	    page = 'last';
	    if ($(container$).data('voc-scribblelive-page')) {
	      page = $(container$).data('voc-scribblelive-page');
	    }
	
	    url = _constants.DEFAULTS.SL_valor_evento1URLPaginaDetalle;
	    if ($(container$).data('voc-scribblelive-url')) {
	      url = $(container$).data('voc-scribblelive-url');
	    }
	
	    site = app.lookup('vocento.site');
	    editions = app.lookup('vocento.site.editions');
	
	    $.extend(options, _constants.DEFAULTS, {
	      medio: site.media,
	      edicion: editions.current,
	      Scribble_pageElementId: id,
	      SL_valor_evento1ID: container$.data('voc-scribblelive'),
	      Scribble_template: template,
	      SL_valor_numeroMensajesPagina: hits,
	      SL_valor_evento1URLPaginaDetalle: url,
	      PageNumber: page,
	      container$: container$
	    });
	    container$.empty();
	    (0, _scribblelive.SL_construyeModulo)(options);
	  });
	}

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = {
		"name": "scribble-live",
		"version": "2.0.2",
		"description": "",
		"main": "src/index.js",
		"scripts": {
			"start": "webpack-dev-server",
			"build": "./node_modules/webpack/bin/webpack.js"
		},
		"contributors": [
			"Iván Pérez <ivanperez@vocento.com>",
			"Jose Manuel Ortega <jmortega@vocento.com>",
			"Adolfo Sanz <asanz@vocento.com>"
		],
		"license": "SEE LICENSE IN LICENSE.md",
		"devDependencies": {
			"babel-core": "^6.17.0",
			"babel-loader": "^6.2.5",
			"babel-preset-es2015": "^6.16.0",
			"chai": "^3.5.0",
			"chalk": "^1.1.3",
			"html-loader": "^0.4.5",
			"html-webpack-plugin": "^2.24.1",
			"json-loader": "^0.5.4",
			"mocha": "^3.1.0",
			"mocha-loader": "^1.0.0",
			"webpack": "^1.13.2",
			"webpack-shell-plugin": "^0.4.3"
		}
	};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SL_cambiaPestana = SL_cambiaPestana;
	exports.SL_construyeModulo = SL_construyeModulo;
	exports.InvocaScribbleLive = InvocaScribbleLive;
	
	var _tempo = __webpack_require__(3);
	
	var _tempo2 = _interopRequireDefault(_tempo);
	
	var _constants = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// tempo.js - http://tempojs.com/
	var _Voonto = Voonto,
	    $ = _Voonto.$,
	    moment = _Voonto.moment;
	
	
	moment.locale(_constants.DEFAULTS.relativeTimeLanguage);
	
	// FUTURE: refactor
	
	/* ----------------------------------------------------------------------------------------------------------
	-------------------------------------------------------------------------------------------------------------
	-------------------------------------------------------------------------------------------------------------
	-------------------------------------------------------------------------------------------------------------
	                      VARIABLES GLOBALES
	-------------------------------------------------------------------------------------------------------------
	-------------------------------------------------------------------------------------------------------------
	-------------------------------------------------------------------------------------------------------------
	-----------------------------------------------------------------------------------------------------------*/
	// Objeto XMLHttpRequest para los distintos navegadores
	var xmlHttp = false;
	// Resultado de la llamada repetitiva para obtener nuevos mensajes
	var Wait;
	// Tipo de especial
	var tipoEspecial = "";
	// Módulo o artículo
	var isArticulo = false;
	// Expresión regular para encontrar vídeos de Brightcove
	var reBC = /##(<small>)?([a-zA-Z0-9-\s_]{3,60})(<\/small>)?##/;
	// Url de la página de detalle del evento
	var gUrlPaginaDetalle;
	// Título de la pestaña activa
	var gTituloPestana;
	// Índice para los eventos múltiples del script
	var instanceIndex;
	// Número total de páginas del evento
	var lastPage;
	// Nueva página a mostrar cuando se hace la paginación
	var pageToGet;
	// Tipo de obtención de mensajes. false cuando se obtienen los mensajes más recientes, true cuando es una llamada para obtener más páginas
	var lastMessages;
	
	// Funciones de jquery para comprobar si un div está antes o después de otro
	(function ($) {
	  $.fn.isAfter = function (sel) {
	    return this.prevAll().filter(sel).length !== 0;
	  };
	  $.fn.isBefore = function (sel) {
	    return this.nextAll().filter(sel).length !== 0;
	  };
	})($);
	
	/* ----------------------------------------------------------------------------------------------------------
	-------------------------------------------------------------------------------------------------------------
	-------------------------------------------------------------------------------------------------------------
	-------------------------------------------------------------------------------------------------------------
	              CÓDIGO ESPECÍFICO PARA MOSTRAR COMPARTIR EN FACEBOOK
	-------------------------------------------------------------------------------------------------------------
	-------------------------------------------------------------------------------------------------------------
	-------------------------------------------------------------------------------------------------------------
	-----------------------------------------------------------------------------------------------------------*/
	
	/* by Steven Yang, Feb 2015, originally for www.mathscore.com.  This code is free for anybody to use as long as you include this comment.  */
	function FacebookFeedDialog(appID, linkTarget, redirectTarget) {
	  this.mParams = {
	    app_id: appID,
	    link: linkTarget,
	    redirect_uri: redirectTarget,
	    display: "popup"
	  };
	};
	
	/* Common params include:
	name - the title that appears in bold font
	description - the text that appears below the title
	picture - complete URL path to the image on the left of the dialog
	caption - replaces the link text
	*/
	FacebookFeedDialog.prototype.addParam = function (key, value) {
	  this.mParams[key] = value;
	};
	
	FacebookFeedDialog.prototype.open = function () {
	  var url = 'https://www.facebook.com/dialog/feed?' + encodeCGIArgs(this.mParams);
	  popup(url, 'feedDialog', 700, 400);
	};
	
	/* Takes a param object like this:
	  { arg1: "value1", arg2: "value2" }
	  and converts into CGI args like this:
	  arg1=value1&arg2=value2
	
	  The values and args will be properly URI encoded
	*/
	function encodeCGIArgs(paramObject) {
	  var result = '';
	  for (var key in paramObject) {
	    if (result) result += '&';
	    result += encodeURIComponent(key) + '=' + encodeURIComponent(paramObject[key]);
	  }
	  return result;
	}
	
	function popup(mylink, windowname, width, height) {
	  if (!window.focus) return;
	  var href;
	  if (typeof mylink == 'string') href = mylink;else href = mylink.href;
	  if (!windowname) windowname = 'mywindow';
	  if (!width) width = 600;
	  if (!height) height = 350;
	  window.open(href, windowname, 'resizable=yes,width=' + width + ',height=' + height + ',scrollbars=yes');
	}
	
	/* ----------------------------------------------------------------------------------------------------------
	-------------------------------------------------------------------------------------------------------------
	-------------------------------------------------------------------------------------------------------------
	-------------------------------------------------------------------------------------------------------------
	                      FUNCIONES GENERALES
	-------------------------------------------------------------------------------------------------------------
	-------------------------------------------------------------------------------------------------------------
	-------------------------------------------------------------------------------------------------------------
	-----------------------------------------------------------------------------------------------------------*/
	
	/**
	 * Obtiene el objeto XMLHttpRequest del navegador. Como siempre IE dando por el culo
	 * @returns Objeto XMLHttpRequest propio del navegador
	 */
	function getHTTPObject() {
	  var xhr = false;
	  if (window.XMLHttpRequest) {
	    var xhr = new XMLHttpRequest();
	  } else if (window.ActiveXObject) {
	    try {
	      var xhr = new ActiveXObject("Msxml2.XMLHTTP");
	    } catch (e) {
	      try {
	        var xhr = new ActiveXObject("Microsoft.XMLHTTP");
	      } catch (e) {
	        xhr = false;
	      }
	    }
	  }
	  return xhr;
	}
	
	/**
	 * Resultado del callback para obtener la plantilla de cada mensaje del módulo
	 * @returns Contenido (cadena) con el contenido de la plantilla para mostrar cada uno de los mensajes del módulo
	 */
	function callbackFunction() {
	  if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
	    return xmlHttp.responseText;
	  }
	}
	
	/**
	 * Obtiene el resizer para el medio
	 * @returns {String} URL del resizer del medio
	 */
	function getMediaResizerUrl() {
	  var resizerUrl = "http://resizer.";
	  var media = Voonto.getInstance().lookup('vocento.site.media');
	  if (media.indexOf("diariovasco") > -1 || media.indexOf("larioja") > -1 || media.indexOf("elcorreo") > -1 || media.indexOf("leonoticias") > -1) {
	    resizerUrl = resizerUrl + media + ".com";
	  } else if (media.indexOf("elbierzonoticias") > -1) {
	    resizerUrl = resizerUrl + "leonoticias.com";
	  } else {
	    resizerUrl = resizerUrl + media + ".es";
	  }
	  return resizerUrl;
	}
	
	/**
	 * Obtiene si una imagen contenida en una url es interna o externa los medios locales
	 * @param url Url de la imagen
	 * @returns {Boolean} Verdadero si la imagen pertenece a un medio local, falso si es una imagen externa
	 */
	function isUrlImagenInterna(url) {
	  var domain;
	  try {
	    if (url.indexOf("://") > -1) {
	      domain = url.split('/')[2];
	    } else {
	      domain = url.split('/')[0];
	    }
	    domain = domain.split(':')[0];
	    if (domain.indexOf("elcorreo.com") > -1 || domain.indexOf("diariovasco.com") > -1 || domain.indexOf("elcomercio.es") > -1 || domain.indexOf("eldiariomontanes.es") > -1 || domain.indexOf("larioja.com") > -1 || domain.indexOf("elnortedecastilla.es") > -1 || domain.indexOf("leonoticias.com") > -1 || domain.indexOf("hoy.es") > -1 || domain.indexOf("ideal.es") > -1 || domain.indexOf("laverdad.es") > -1 || domain.indexOf("lasprovincias.es") > -1 || domain.indexOf("elbierzonoticias.com") > -1) {
	      return true;
	    } else {
	      return false;
	    }
	  } catch (e) {
	    return false;
	  }
	}
	
	/**
	 * Formatea un mensaje para las redes sociales. Si hay código html en el mensaje entonces se obvia
	 * y se recoge en su lugar el título de la pestaña
	 * @param mensaje Mensaje para formatear
	 * @param tituloPestana Título de la pestaña. Texto a usar por defecto cuando no hay mensaje
	 * @param comillas Indica si debe escapar las comillas dobles y simples (Facebook) o no escaparlas (Twitter)
	 * @returns Mensaje formateado
	 */
	function formatMensaje(mensaje, tituloPestana, comillas) {
	
	  if (typeof tituloPestana == "undefined") {
	    tituloPestana = gTituloPestana;
	  }
	  // El mensaje será nulo cuando se comparte desde la parte inferior del módulo
	  if (mensaje == null) {
	    mensaje = tituloPestana;
	  }
	  // Elimina un código html que inserta la API de SL y que aquí nos suda la polla
	  if (mensaje.indexOf("ScribbleLiveCountImage") > -1) {
	    mensaje = mensaje.substring(0, mensaje.indexOf("<img class=\"ScribbleLiveCountImage\""));
	  }
	  // Si el mensaje trae html se eliminan todos los tags
	  if (mensaje.indexOf("<") > -1) {
	    mensaje = mensaje.replace(/(<([^>]+)>)/ig, "");
	  }
	  mensaje = $.trim(mensaje);
	  if (comillas) {
	    mensaje = mensaje.replace(/"/g, '\\"');
	    mensaje = mensaje.replace(/'/g, '\\"');
	    mensaje = mensaje.substring(0, 200);
	  } else {
	    mensaje = mensaje.substring(0, 140);
	    mensaje = encodeURI(mensaje);
	    mensaje = mensaje.replace(/'/g, "%27");
	  }
	
	  if (mensaje.length == 0) {
	    mensaje = tituloPestana;
	  }
	
	  return mensaje;
	}
	
	/**
	 * Pasa una url de relativa a absoluta si no lo es
	 * @param url Url a convertir. Si es absoluta se deja tal cual
	 * @returns {String} Url siempre absoluta
	 */
	function urlAbsoluta(url) {
	  if (url.indexOf("http") != 0) {
	    var urlAbs = location.protocol + "//" + document.domain;
	    var edition = Voonto.getInstance().lookup('vocento.site.editions.current');
	    if (edition != null && edition != "null" && edition.replace(/\s/g, "") != "") {
	      urlAbs += "/" + edition;
	    }
	    urlAbs += url;
	    url = urlAbs;
	  }
	  return url;
	}
	
	/**
	 * Averigua si un post tiene como origen Twitter o no
	 * @param post Elemento json con toda la información del post
	 * @param twtpl Template de Twitter
	 * @returns Verdadero si el post tiene como origen Twitter, falso en caso contrario
	 */
	function isTwitterPost(post, twtpl) {
	  try {
	    if ((post.PostMeta.source == "twitter" || post.Source.indexOf("twitter") > -1) && twtpl != null) {
	      return true;
	    } else {
	      return false;
	    }
	  } catch (e) {
	    return false;
	  }
	}
	
	/**
	 * Genera el código HTML para compartir una página en Twitter
	 * @param urlPaginaDetalle URL de la página a compartir
	 * @param tituloPestana Texto explicativo para compartir
	 * @param mensaje Texto del mensaje a compartir. Este parámetro vendrá con valor cuando se comparta un mensaje en concreto
	 * @returns {String} Cadena HTML para compartir en Twitter
	 */
	function twitterShare(urlPaginaDetalle, tituloPestana, mensaje) {
	
	  mensaje = formatMensaje(mensaje, tituloPestana, false);
	  urlPaginaDetalle = typeof urlPaginaDetalle != "undefined" && urlPaginaDetalle.replace(/\s/g, "") != "" ? urlPaginaDetalle : location.href;
	  urlPaginaDetalle = urlAbsoluta(urlPaginaDetalle);
	  var url = 'https://twitter.com/intent/tweet?url=' + escape(urlPaginaDetalle) + '&text=' + mensaje + '&via=' + socialNetworks.getTwitterAccount();
	  var width = 575;
	  var height = 400;
	  var left = ($(window).width() - width) / 2;
	  var top = ($(window).height() - height) / 2;
	  var opts = 'status=1' + ',width=' + width + ',height=' + height + ',top=' + top + ',left=' + left;
	  return '<a href="#" onclick="window.open(\'' + url + '\', \'twitter\', \'' + opts + '\');return false;">T</a>';
	}
	
	/**
	 * Obtiene el id de la aplicación de Facebook según el medio
	 * @returns {String} Id de la aplicación de Facebook del medio
	 */
	function getFBId() {
	  var media = Voonto.getInstance().lookup('vocento.site.media');
	  if (media.indexOf("comercio") > -1) {
	    return "95009241017";
	  } else if (media.indexOf("diariomontanes") > -1) {
	    return "77981614515";
	  } else if (media.indexOf("elcorreo") > -1) {
	    return "101374325995";
	  } else if (media.indexOf("diariovasco") > -1) {
	    return "189716465103";
	  } else if (media.indexOf("larioja") > -1) {
	    return "84755916337";
	  } else if (media.indexOf("nortedecastilla") > -1) {
	    return "85441402889";
	  } else if (media.indexOf("provincias") > -1) {
	    return "192864680242";
	  } else if (media.indexOf("laverdad") > -1) {
	    return "84315835682";
	  } else if (media.indexOf("ideal") > -1) {
	    return "99542490759";
	  } else if (media.indexOf("diariosur") > -1) {
	    return "96373116360";
	  } else if (media.indexOf("hoy") > -1) {
	    return "79017991068";
	  } else if (media.indexOf("leonoticias") > -1 || media.indexOf("elbierzonoticias") > -1) {
	    return "885569074898163";
	  } else {
	    // Por defecto se devuelve el Id de El Correo
	    return "101374325995";
	  }
	}
	
	/**
	 * Código JS para hacer la llamada a Facebook
	 * @param id Id del mensaje de Scribblive. Cuando viene desde la llamada global será un "0"
	 * @param urlPaginaDetalle URL de la página a compartir
	 * @param tituloPestana Texto explicativo para compartir
	 * @param mensaje Texto del mensaje a compartir. Este parámetro vendrá con valor cuando se comparta un mensaje en concreto
	 */
	function addFBShare(id, urlPaginaDetalle, tituloPestana, mensaje) {
	
	  var dialog = new FacebookFeedDialog(getFBId(), urlPaginaDetalle, 'http://' + document.domain + '/comun/html/2014/facebook-redirect-uri.html');
	  dialog.addParam('name', mensaje);
	  // Lotería
	  if (tituloPestana.toLowerCase().indexOf("loter") > -1) {
	    dialog.addParam('description', "Cobertura en directo de la Loter\xEDa de Navidad");
	  } else {
	    dialog.addParam('description', 'Cobertura en directo');
	  }
	  dialog.addParam('picture', 'http://' + document.domain + '/img/2014/logoC-200.png');
	  var media = Voonto.getInstance().lookup('vocento.site.media');
	  dialog.addParam('caption', media);
	
	  dialog.open();
	}
	
	/**
	 * Genera el código HTML para compartir una página en Facebook
	 * @param urlPaginaDetalle URL de la página a compartir
	 * @param tituloPestana Texto explicativo para compartir
	 * @param mensaje Texto del mensaje a compartir. Este parámetro vendrá con valor cuando se comparta un mensaje en concreto
	 * @param id Id del mensaje de Scribblive. Cuando viene desde la llamada global será un "0"
	 * @returns {String} Cadena HTML para compartir en Facebook
	 */
	function facebookShare(urlPaginaDetalle, tituloPestana, mensaje, id) {
	  mensaje = formatMensaje(mensaje, tituloPestana, true);
	  urlPaginaDetalle = typeof urlPaginaDetalle != "undefined" && urlPaginaDetalle.replace(/\s/g, "") != "" ? urlPaginaDetalle : location.href;
	  urlPaginaDetalle = urlAbsoluta(urlPaginaDetalle);
	  var codigoHTMLFacebook = "<a href='#' onclick='addFBShare(" + id + ",\"" + urlPaginaDetalle + "\",\"" + tituloPestana + "\",\"" + mensaje + "\");return false;'>F</a>";
	  return codigoHTMLFacebook;
	}
	
	/**
	 * Carga los mensajes de la anterior página (siempre y cuando haya más de una página)
	 */
	function loadPreviousPage() {
	  if (lastPage > 0) {
	    // Indica que se quieren obtener los últimos mensajes
	    lastMessages = true;
	    // Muestra la capa de carga
	    $("#SL_loadingPages").show();
	    // Obtiene los mensajes de la página anterior
	    InvocaScribbleLive.GetInstance(instanceIndex).GetOldPosts();
	  }
	}
	
	/**
	 * Evento que se lanza al cambiar la pestaña del módulo
	 * @param numPestana Número de pestaña (numérico) a mostrar
	 * @param idEvento Id del evento de la pestaña
	 * @param urlPaginaDetalle URL de la página de detalle de la pestaña
	 * @param escribeCapaJs true cuando se carga el módulo vía JavaScript, false si se carga el iframe
	 * @param SL_valor_numeroMensajesPagina Número de mensajes a mostrar en la pestaña
	 * @param PageNumber Número de la página seleccionada
	 * @param avatar Indica si debe mostrar o no el avatar del usuario
	 * @param ColumnLocation Posición del módulo en la página (C, AB)
	 * @param tituloPestana Título de la pestaña
	 * @param medio Medio donde se muestra el módulo
	 * @param edicion Edición del medio donde se muestra el módulo
	 */
	function SL_cambiaPestana(_ref) {
	  var numPestana = _ref.numPestana,
	      idEvento = _ref.idEvento,
	      urlPaginaDetalle = _ref.urlPaginaDetalle,
	      escribeCapaJs = _ref.escribeCapaJs,
	      SL_valor_numeroMensajesPagina = _ref.SL_valor_numeroMensajesPagina,
	      PageNumber = _ref.PageNumber,
	      avatar = _ref.avatar,
	      ColumnLocation = _ref.ColumnLocation,
	      tituloPestana = _ref.tituloPestana,
	      medio = _ref.medio,
	      edicion = _ref.edicion,
	      SL_valor_plantilla = _ref.SL_valor_plantilla,
	      Scribble_ancho = _ref.Scribble_ancho,
	      Scribble_alto = _ref.Scribble_alto,
	      Scribble_pageElementId = _ref.Scribble_pageElementId,
	      Scribble_template = _ref.Scribble_template,
	      Scribble_Iframe_API = _ref.Scribble_Iframe_API,
	      APIToken = _ref.APIToken,
	      Scribble_API = _ref.Scribble_API,
	      container$ = _ref.container$;
	
	
	  // Se lee la plantilla interna de Scribble a utilizar. Si no hay ninguna definida se utiliza la plantilla por defecto
	
	  var marcadorManualActivo = false;
	  // Obtiene los valores de alto y ancho
	  var SL_valor_ancho = '300';
	  var SL_valor_ancho_embebido = '300';
	  if (typeof Scribble_ancho != "undefined") {
	    try {
	      SL_valor_ancho = Scribble_ancho;
	      if (SL_valor_ancho.indexOf('px') != -1) {
	        SL_valor_ancho = SL_valor_ancho.replace('px', '');
	      }
	      var ancho = parseInt(SL_valor_ancho);
	      SL_valor_ancho_embebido = ancho;
	      $(".SL_moduloDirecto").css("width", "" + ancho + "px");
	    } catch (err) {}
	  }
	
	  var SL_valor_alto = '450';
	  var SL_valor_alto_embebido = '340';
	  if (typeof Scribble_alto != "undefined") {
	    try {
	      SL_valor_alto = Scribble_alto;
	      var alto = parseInt(SL_valor_alto);
	      SL_valor_alto_embebido = alto - 110;
	      if (typeof voc_pl == "undefined" || voc_pl != 'm') {
	        $(".SL_moduloDirecto").css("height", "" + alto + "px");
	        $("#SL_evento").css("height", "" + (alto - 70) + "px");
	      }
	    } catch (err) {}
	  }
	
	  // Id de la capa donde se escribirá el contenido de Scribblelive
	  var pageElementId = "SL_evento";
	  if (typeof Scribble_pageElementId != "undefined") {
	    pageElementId = Scribble_pageElementId;
	  }
	  // Carga rápida
	
	  if (escribeCapaJs) {
	    var template = "";
	    if (typeof Scribble_template != "undefined") {
	      template = Scribble_template;
	    }
	    var templateTwitter = null;
	    if (typeof Scribble_template_twitter != "undefined") {
	      templateTwitter = Scribble_template_twitter;
	    }
	    var dateFormat = "DD/MM - HH:mm";
	    if (typeof Scribble_dateFormat != "undefined") {
	      dateFormat = Scribble_dateFormat;
	    }
	    var todayDateFormat = "HH:mm:ss";
	    if (typeof Scribble_todayDateFormat != "undefined") {
	      todayDateFormat = Scribble_todayDateFormat;
	    }
	    // Borra todo contenido donde se van a mostrar los mensajes de Scribblelive
	    $("#" + pageElementId).html("");
	    // Invoca a Scribble
	    var ScribbleLiveInstance = new InvocaScribbleLive({
	      "APIToken": APIToken,
	      "EventId": idEvento,
	      container$: container$,
	      "TotalPostsToShow": SL_valor_numeroMensajesPagina,
	      "DateFormat": dateFormat,
	      "TodayDateFormat": todayDateFormat,
	      "PageElementId": pageElementId,
	      "ShowAvatars": avatar,
	      "Template": template,
	      "TemplateTwitter": templateTwitter,
	      "HTMLElementId": "scribbleContent",
	      "ColumnLocation": ColumnLocation,
	      "Medio": medio,
	      "Edicion": edicion,
	      "UrlPaginaDetalle": urlPaginaDetalle,
	      "Scribble_API": Scribble_API,
	      "PageNumber": PageNumber
	    });
	  } else {
	    // Se muestra el iframe
	    var codigoHTMLIframe = '<iframe id="SL_iframe" src="' + Scribble_Iframe_API + '?Id=' + idEvento + '&ThemeId=' + SL_valor_plantilla + '&medio=' + medio + '&edicion=' + edicion + '" width="' + SL_valor_ancho_embebido + '" height="' + SL_valor_alto_embebido + '" frameborder="0" allowtransparency="true"></iframe>';
	    $("#" + pageElementId).html(codigoHTMLIframe).ready(function () {
	      $("#SL_imagenCargando").hide();
	    });
	  }
	
	  // Enlace a la pagina de detalle
	  if (urlPaginaDetalle != null && urlPaginaDetalle != 'null') {
	    // Si la url lleva a live.vocento.com se añade medio y edición
	    if (urlPaginaDetalle.indexOf("live.vocento.com/scribblelive/redirect.php?recid=") > -1 && urlPaginaDetalle.indexOf("medio=") == -1) {
	      var re = new RegExp("recid=([^&].*)");
	      var parametrosLlamada = "&medio=" + medio;
	      if (edicion != null && edicion != "null" && edicion.replace(/\s/g, "") != "") {
	        parametrosLlamada = parametrosLlamada + "&edicionLocal=" + edicion;
	      }
	      urlPaginaDetalle = urlPaginaDetalle.replace(re, "recid=$1" + parametrosLlamada);
	    }
	    // Asignación de la variable global
	    gUrlPaginaDetalle = urlPaginaDetalle;
	    var codigoHTMLURLPaginaDetalle = '<a href="' + urlPaginaDetalle + '" target="_blank" title="Ir a p&aacute;gina de detalle del evento">Ver cobertura completa</a>';
	    $("#SL_coberturaCompleta").html(codigoHTMLURLPaginaDetalle);
	    if (tipoEspecial != "elecciones-2015") {
	      $("#SL_coberturaCompleta").show();
	    }
	
	    if (urlPaginaDetalle.indexOf('redirect.php') == -1 || tipoEspecial == "elecciones-2015" || tipoEspecial == "nuevo") {
	      // Se muestran los iconos de las redes sociales. El de Twitter no lleva URL como parametro así que no hace falta sobreescribirlo
	      if (tituloPestana == null || tituloPestana.replace(/\s/g, "") == "") {
	        tituloPestana = "Actualidad en directo";
	      }
	      if ((tipoEspecial == "elecciones-2015" || tipoEspecial == "nuevo") && typeof Scribble_posicionColumna != "undefined" && Scribble_posicionColumna != "AB") {
	        var codigoHTMLTwitter = twitterShare(urlPaginaDetalle, tituloPestana, null);
	        var codigoHTMLFacebook = facebookShare(urlPaginaDetalle, tituloPestana, null, '0');
	      } else {
	        var codigoHTMLFacebook = '<iframe scrolling="no" frameborder="0" allowtransparency="true" style="border: medium none; overflow: hidden; width: 125px; height: 22px;" src="http://www.facebook.com/plugins/like.php?href=' + urlPaginaDetalle + '&amp;layout=button_count&amp;show_faces=true&amp;width=120&amp;action=recommend&amp;font=arial&amp;colorscheme=light&amp;height=21"></iframe>';
	        var codigoHTMLTwitter = '<a href="http://twitter.com/share" class="twitter-share-button" data-url="' + urlPaginaDetalle + '" data-text="' + tituloPestana + '" data-count="horizontal">Tweet</a><script type="text/javascript" src="http://platform.twitter.com/widgets.js"></script>';
	      }
	      $("#SL_iconoFacebook").html(codigoHTMLFacebook);
	      $("#SL_iconoTwitter").html(codigoHTMLTwitter);
	      $("#SL_iconos").show();
	    } else {
	      $("#SL_iconos").hide();
	    }
	    // Iframe
	  } else {
	    $("#SL_coberturaCompleta").hide();
	    $("#SL_iconos").hide();
	  }
	
	  if (document.getElementById("contentMarcador" + numPestana + "Manual")) {
	    $("#SL_marcadoresDirecto").css("margin-top", "44px");
	  } else {
	    $("#SL_marcadoresDirecto").css("margin-top", "0px");
	  }
	
	  // Se marca como activa la pestaña correspondiente y se desactivan las demás
	  if (!$("#SL_pestana" + numPestana).hasClass('activo')) {
	    $("#SL_pestana" + numPestana).addClass('activo');
	    if (document.getElementById("SL_marcadorDirecto" + numPestana) && $.trim(document.getElementById("SL_marcadorDirecto" + numPestana).innerHTML) != '') {
	      $("#SL_marcadorDirecto" + numPestana).show();
	    }
	  }
	  if (numPestana != 1 && $("#SL_pestana1").hasClass('activo')) {
	    $("#SL_pestana1").removeClass('activo');
	    $("#SL_marcadorDirecto1").hide();
	  }
	  if (numPestana != 2 && $("#SL_pestana2").hasClass('activo')) {
	    $("#SL_pestana2").removeClass('activo');
	    $("#SL_marcadorDirecto2").hide();
	  }
	  if (numPestana != 3 && $("#SL_pestana3").hasClass('activo')) {
	    $("#SL_pestana3").removeClass('activo');
	    $("#SL_marcadorDirecto3").hide();
	  }
	  if (numPestana != 4 && $("#SL_pestana4").hasClass('activo')) {
	    $("#SL_pestana4").removeClass('activo');
	    $("#SL_marcadorDirecto4").hide();
	  }
	
	  // Asignación de la variable global
	  gTituloPestana = tituloPestana;
	}
	
	/**
	 * Llamada principal para construir el módulo de Scribble y obtener los mensajes
	 * @param medio Medio donde se construye el módulo
	 * @param edicion Edición de se construye el módulo
	 */
	function SL_construyeModulo(_ref2) {
	  var medio = _ref2.medio,
	      edicion = _ref2.edicion,
	      escribeCapaJs = _ref2.escribeCapaJs,
	      ColumnLocation = _ref2.ColumnLocation,
	      avatar1 = _ref2.avatar1,
	      avatar2 = _ref2.avatar2,
	      avatar3 = _ref2.avatar3,
	      avatar4 = _ref2.avatar4,
	      SL_valor_epigrafe = _ref2.SL_valor_epigrafe,
	      SL_url_epigrafe = _ref2.SL_url_epigrafe,
	      Scribble_tipoEspecial = _ref2.Scribble_tipoEspecial,
	      SL_valor_numeroMensajesPagina = _ref2.SL_valor_numeroMensajesPagina,
	      PageNumber = _ref2.PageNumber,
	      SL_valor_evento1ID = _ref2.SL_valor_evento1ID,
	      SL_valor_evento1Titulo = _ref2.SL_valor_evento1Titulo,
	      SL_valor_evento1URLPaginaDetalle = _ref2.SL_valor_evento1URLPaginaDetalle,
	      SL_valor_evento2ID = _ref2.SL_valor_evento2ID,
	      SL_valor_evento2Titulo = _ref2.SL_valor_evento2Titulo,
	      SL_valor_evento2URLPaginaDetalle = _ref2.SL_valor_evento2URLPaginaDetalle,
	      SL_valor_evento3ID = _ref2.SL_valor_evento3ID,
	      SL_valor_evento3Titulo = _ref2.SL_valor_evento3Titulo,
	      SL_valor_evento3URLPaginaDetalle = _ref2.SL_valor_evento3URLPaginaDetalle,
	      SL_valor_evento4ID = _ref2.SL_valor_evento4ID,
	      SL_valor_evento4Titulo = _ref2.SL_valor_evento4Titulo,
	      SL_valor_evento4URLPaginaDetalle = _ref2.SL_valor_evento4URLPaginaDetalle,
	      SL_valor_plantilla = _ref2.SL_valor_plantilla,
	      Scribble_ancho = _ref2.Scribble_ancho,
	      Scribble_alto = _ref2.Scribble_alto,
	      Scribble_pageElementId = _ref2.Scribble_pageElementId,
	      Scribble_template = _ref2.Scribble_template,
	      Scribble_template_twitter = _ref2.Scribble_template_twitter,
	      Scribble_dateFormat = _ref2.Scribble_dateFormat,
	      Scribble_todayDateFormat = _ref2.Scribble_todayDateFormat,
	      Scribble_Iframe_API = _ref2.Scribble_Iframe_API,
	      APIToken = _ref2.APIToken,
	      Scribble_API = _ref2.Scribble_API,
	      container$ = _ref2.container$;
	
	
	  // Se obtienen los mensajes más nuevos
	  lastMessages = false;
	
	  if (ColumnLocation == "AB") {
	    isArticulo = true;
	  }
	
	  tipoEspecial = Scribble_tipoEspecial;
	
	  if (SL_url_epigrafe != null && (SL_url_epigrafe.indexOf("http://") > -1 || SL_url_epigrafe.indexOf("https://") > -1)) {
	    // Si la url lleva a live.vocento.com se añade medio y edición
	    if (SL_url_epigrafe.indexOf("live.vocento.com/scribblelive/redirect.php?recid=") > -1 && SL_url_epigrafe.indexOf("medio=") == -1) {
	      var re = new RegExp("recid=([^&].*)");
	      var parametrosLlamada = "&medio=" + medio;
	      if (edicion != null && edicion != "null" && edicion.replace(/\s/g, "") != "") {
	        parametrosLlamada = parametrosLlamada + "&edicionLocal=" + edicion;
	      }
	      SL_url_epigrafe = SL_url_epigrafe.replace(re, "recid=$1" + parametrosLlamada);
	    }
	    SL_valor_epigrafe = "<a href=\"" + SL_url_epigrafe + "\" target=\"_blank\">" + SL_valor_epigrafe + "</a>";
	  }
	  if ((tipoEspecial == "elecciones-2015" || tipoEspecial == "nuevo") && SL_url_epigrafe != null) {
	    $("#enlaceSLElecciones2015").attr("href", urlAbsoluta(SL_url_epigrafe));
	  } else {
	    $("#SL_epigrafe").html(SL_valor_epigrafe);
	    $("#SL_epigrafe").show();
	  }
	
	  var marcadorManualActivo = false;
	  // Eventos. Si hay más de uno se muestran las pestañas
	  var numEventos = 0;
	
	  if ((tipoEspecial == "elecciones-2015" || tipoEspecial == "nuevo") && typeof SL_valor_evento1URLPaginaDetalle != "undefined" && SL_valor_evento1URLPaginaDetalle != null && SL_valor_evento1URLPaginaDetalle != "") {
	    var urlAbs = urlAbsoluta(SL_valor_evento1URLPaginaDetalle);
	    $("#spanSDElecciones2015").html("<a href=\"" + urlAbs + "\">Sigue el Directo</a>");
	  }
	  if (SL_valor_evento1ID != null && SL_valor_evento1ID != "" && SL_valor_evento1Titulo != null) {
	    var cambiaPestanaCfg = {
	      escribeCapaJs: escribeCapaJs,
	      ColumnLocation: ColumnLocation,
	      SL_valor_numeroMensajesPagina: SL_valor_numeroMensajesPagina,
	      PageNumber: PageNumber,
	      medio: medio,
	      edicion: edicion,
	      SL_valor_plantilla: SL_valor_plantilla,
	      Scribble_ancho: Scribble_ancho,
	      Scribble_alto: Scribble_alto,
	      Scribble_pageElementId: Scribble_pageElementId,
	      Scribble_template: Scribble_template,
	      Scribble_template_twitter: Scribble_template_twitter,
	      Scribble_dateFormat: Scribble_dateFormat,
	      Scribble_todayDateFormat: Scribble_todayDateFormat,
	      Scribble_Iframe_API: Scribble_Iframe_API,
	      APIToken: APIToken,
	      Scribble_API: Scribble_API,
	      numPestana: 1,
	      idEvento: SL_valor_evento1ID,
	      urlPaginaDetalle: SL_valor_evento1URLPaginaDetalle,
	      avatar: avatar1,
	      tituloPestana: SL_valor_evento1Titulo
	    };
	    var strCfg = JSON.stringify(cambiaPestanaCfg);
	    var codigoHTMLPestana1 = '<a href="javascript:SL_cambiaPestana(' + strCfg + ');" alt="' + SL_valor_evento1Titulo + '">' + SL_valor_evento1Titulo + '</a>';
	    $("#SL_pestana1").html(codigoHTMLPestana1);
	    if (document.getElementById("contentMarcador1") && $.trim(document.getElementById("contentMarcador1").innerHTML) != '') {
	      $("#SL_marcadorDirecto1").html(document.getElementById("contentMarcador1").innerHTML);
	      if (document.getElementById("contentMarcador1Manual")) {
	        $("#SL_marcadorDirecto1").addClass("nmarcador");
	        $("#SL_marcadoresDirecto").addClass("noticia-marcador");
	        $("#SL_marcadoresDirecto").css("position", "relative");
	        marcadorManualActivo = true;
	      }
	      $("#SL_marcadorDirecto1").show();
	    }
	    numEventos++;
	  }
	
	  if (SL_valor_evento2ID != null && SL_valor_evento2ID != "" && SL_valor_evento2Titulo != null) {
	    var _cambiaPestanaCfg = {
	      escribeCapaJs: escribeCapaJs,
	      ColumnLocation: ColumnLocation,
	      SL_valor_numeroMensajesPagina: SL_valor_numeroMensajesPagina,
	      PageNumber: PageNumber,
	      medio: medio,
	      edicion: edicion,
	      SL_valor_plantilla: SL_valor_plantilla,
	      Scribble_ancho: Scribble_ancho,
	      Scribble_alto: Scribble_alto,
	      Scribble_pageElementId: Scribble_pageElementId,
	      Scribble_template: Scribble_template,
	      Scribble_template_twitter: Scribble_template_twitter,
	      Scribble_dateFormat: Scribble_dateFormat,
	      Scribble_todayDateFormat: Scribble_todayDateFormat,
	      Scribble_Iframe_API: Scribble_Iframe_API,
	      APIToken: APIToken,
	      Scribble_API: Scribble_API,
	      numPestana: 2,
	      idEvento: SL_valor_evento2ID,
	      urlPaginaDetalle: SL_valor_evento2URLPaginaDetalle,
	      avatar: avatar2,
	      tituloPestana: SL_valor_evento2Titulo
	    };
	    var _strCfg = JSON.stringify(_cambiaPestanaCfg);
	    var codigoHTMLPestana2 = '<a href="javascript:SL_cambiaPestana(' + _strCfg + ');" alt="' + SL_valor_evento2Titulo + '">' + SL_valor_evento2Titulo + '</a>';
	    $("#SL_pestana2").html(codigoHTMLPestana2);
	    $("#SL_pestana2").show();
	    if (document.getElementById("contentMarcador2") && $.trim(document.getElementById("contentMarcador2").innerHTML) != '') {
	
	      $("#SL_marcadorDirecto2").html(document.getElementById("contentMarcador2").innerHTML);
	      if (document.getElementById("contentMarcador2Manual")) {
	        $("#SL_marcadorDirecto2").addClass("nmarcador");
	        $("#SL_marcadoresDirecto").addClass("noticia-marcador");
	        $("#SL_marcadoresDirecto").css("position", "relative");
	      }
	    }
	    numEventos++;
	  }
	
	  if (SL_valor_evento3ID != null && SL_valor_evento3ID != "" && SL_valor_evento3Titulo != null) {
	    var _cambiaPestanaCfg2 = {
	      escribeCapaJs: escribeCapaJs,
	      ColumnLocation: ColumnLocation,
	      SL_valor_numeroMensajesPagina: SL_valor_numeroMensajesPagina,
	      PageNumber: PageNumber,
	      medio: medio,
	      edicion: edicion,
	      SL_valor_plantilla: SL_valor_plantilla,
	      Scribble_ancho: Scribble_ancho,
	      Scribble_alto: Scribble_alto,
	      Scribble_pageElementId: Scribble_pageElementId,
	      Scribble_template: Scribble_template,
	      Scribble_template_twitter: Scribble_template_twitter,
	      Scribble_dateFormat: Scribble_dateFormat,
	      Scribble_todayDateFormat: Scribble_todayDateFormat,
	      Scribble_Iframe_API: Scribble_Iframe_API,
	      APIToken: APIToken,
	      Scribble_API: Scribble_API,
	      numPestana: 3,
	      idEvento: SL_valor_evento3ID,
	      urlPaginaDetalle: SL_valor_evento3URLPaginaDetalle,
	      avatar: avatar3,
	      tituloPestana: SL_valor_evento3Titulo
	    };
	    var _strCfg2 = JSON.stringify(_cambiaPestanaCfg2);
	    var codigoHTMLPestana3 = '<a href="javascript:SL_cambiaPestana(' + _strCfg2 + ');" alt="' + SL_valor_evento3Titulo + '">' + SL_valor_evento3Titulo + '</a>';
	    $("#SL_pestana3").html(codigoHTMLPestana3);
	    $("#SL_pestana3").show();
	    if (document.getElementById("contentMarcador3") && $.trim(document.getElementById("contentMarcador3").innerHTML) != '') {
	      $("#SL_marcadorDirecto3").html(document.getElementById("contentMarcador3").innerHTML);
	      if (document.getElementById("contentMarcador3Manual")) {
	        $("#SL_marcadorDirecto3").addClass("nmarcador");
	        $("#SL_marcadoresDirecto").addClass("noticia-marcador");
	        $("#SL_marcadoresDirecto").css("position", "relative");
	      }
	    }
	    numEventos++;
	  }
	
	  if (SL_valor_evento4ID != null && SL_valor_evento4ID != "" && SL_valor_evento4Titulo != null) {
	    var _cambiaPestanaCfg3 = {
	      escribeCapaJs: escribeCapaJs,
	      ColumnLocation: ColumnLocation,
	      SL_valor_numeroMensajesPagina: SL_valor_numeroMensajesPagina,
	      PageNumber: PageNumber,
	      medio: medio,
	      edicion: edicion,
	      SL_valor_plantilla: SL_valor_plantilla,
	      Scribble_ancho: Scribble_ancho,
	      Scribble_alto: Scribble_alto,
	      Scribble_pageElementId: Scribble_pageElementId,
	      Scribble_template: Scribble_template,
	      Scribble_template_twitter: Scribble_template_twitter,
	      Scribble_dateFormat: Scribble_dateFormat,
	      Scribble_todayDateFormat: Scribble_todayDateFormat,
	      Scribble_Iframe_API: Scribble_Iframe_API,
	      APIToken: APIToken,
	      Scribble_API: Scribble_API,
	      numPestana: 4,
	      idEvento: SL_valor_evento4ID,
	      urlPaginaDetalle: SL_valor_evento4URLPaginaDetalle,
	      avatar: avatar4,
	      tituloPestana: SL_valor_evento4Titulo
	    };
	    var _strCfg3 = JSON.stringify(_cambiaPestanaCfg3);
	
	    var codigoHTMLPestana4 = '<a href="javascript:SL_cambiaPestana(' + _strCfg3 + ');" alt="' + SL_valor_evento4Titulo + '">' + SL_valor_evento4Titulo + '</a>';
	    $("#SL_pestana4").html(codigoHTMLPestana4);
	    $("#SL_pestana4").show();
	    if (document.getElementById("contentMarcador4") && $.trim(document.getElementById("contentMarcador4").innerHTML) != '') {
	      $("#SL_marcadorDirecto4").html(document.getElementById("contentMarcador4").innerHTML);
	      if (document.getElementById("contentMarcador4Manual")) {
	        $("#SL_marcadorDirecto4").addClass("nmarcador");
	        $("#SL_marcadoresDirecto").addClass("noticia-marcador");
	        $("#SL_marcadoresDirecto").css("position", "relative");
	      }
	    }
	    numEventos++;
	  }
	
	  if (marcadorManualActivo) {
	    $("#SL_marcadoresDirecto").css("margin-top", "44px");
	  }
	  if (numEventos < 2) {
	    // No se muestran las pestañas
	    $("#SL_pestanas").css("display", "none");
	  } else {
	    // Se muestran las pestañas al haber más de un evento activo
	    $("#SL_pestanas").css("display", "block");
	  }
	
	  // Por defecto siempre se muestra el primer evento
	  SL_cambiaPestana({
	    escribeCapaJs: escribeCapaJs,
	    ColumnLocation: ColumnLocation,
	    SL_valor_numeroMensajesPagina: SL_valor_numeroMensajesPagina,
	    PageNumber: PageNumber,
	    medio: medio,
	    edicion: edicion,
	    SL_valor_plantilla: SL_valor_plantilla,
	    Scribble_ancho: Scribble_ancho,
	    Scribble_alto: Scribble_alto,
	    Scribble_pageElementId: Scribble_pageElementId,
	    Scribble_template: Scribble_template,
	    Scribble_template_twitter: Scribble_template_twitter,
	    Scribble_dateFormat: Scribble_dateFormat,
	    Scribble_todayDateFormat: Scribble_todayDateFormat,
	    Scribble_Iframe_API: Scribble_Iframe_API,
	    APIToken: APIToken,
	    Scribble_API: Scribble_API,
	    numPestana: 1,
	    idEvento: SL_valor_evento1ID,
	    urlPaginaDetalle: SL_valor_evento1URLPaginaDetalle,
	    avatar: avatar1,
	    tituloPestana: SL_valor_evento1Titulo,
	    container$: container$
	  });
	  $("#SL_pestana1").addClass('activo');
	}
	
	/* ----------------------------------------------------------------------------------------------------------
	-------------------------------------------------------------------------------------------------------------
	-------------------------------------------------------------------------------------------------------------
	-------------------------------------------------------------------------------------------------------------
	              CÓDIGO ESPECÍFICO PARA MOSTRAR LOS MENSAJES DE SCRIBBLELIVE
	-------------------------------------------------------------------------------------------------------------
	-------------------------------------------------------------------------------------------------------------
	-------------------------------------------------------------------------------------------------------------
	-----------------------------------------------------------------------------------------------------------*/
	
	function InvocaScribbleLive(Opciones) {
	
	  // Inicialización por defecto de los parámetros de Scribble
	  this.Opciones = {
	    // You can find your API tokens - and generate new ones - under the general API section of your ScribbleLive back end. https://client.scribblelive.com/client/API.aspx
	    APIToken: "",
	    // You can find your event id under the API section of your event in the ScribbleLive back end. You can also view source on your event and search for "ThreadId".
	    EventId: "",
	    // The number of posts you would like to display.
	    TotalPostsToShow: 10,
	    // Show images, true or false.
	    ShowImages: true,
	    // Show videos, true or false.
	    ShowVideos: true,
	    // Show audio, true or false.
	    ShowAudio: true,
	    // Show stuck posts, true or false.
	    ShowStuckPosts: true,
	    //Show avatars, true or false.
	    ShowAvatars: false,
	    // Show text posts, true or false.
	    ShowTextPosts: true,
	    // Show polls, true or false.
	    ShowPolls: false,
	    // Show media captions, true or false.
	    ShowCaptions: true,
	    // Show comments, true or false.
	    ShowComments: true,
	    // Show official (writer, editor, moderator, administrator, guest writer, etc.) posts, true or false.
	    ShowOfficialPosts: true,
	    // Show Twitter posts, true or false.
	    ShowTweets: true,
	    // Show mobile posts, true of false.
	    ShowMobilePosts: true,
	    // Show Facebook posts, true or false.
	    ShowFacebookPosts: true,
	    // Show only Twitter posts, true or false.
	    ShowOnlyTweets: false,
	    // Show only Facebook posts, true or false.
	    ShowOnlyFacebookPosts: false,
	    // Show only polls, true or false.
	    ShowOnlyPolls: false,
	    // Tiempo de recarga
	    AutoUpdateTimeOut: 10,
	    // Formato de fecha para un mensaje anterior al día de hoy
	    DateFormat: "HH:mm:ss",
	    // Formato de fecha para un mensaje del día de hoy
	    TodayDateFormat: "HH:mm:ss",
	    // Id de la capa donde irá incrustado todo el contenido de ScribbleLive
	    PageElementId: "",
	    // Ruta de la plantilla que se usará para mostrar cada uno de los mensajes
	    Template: "",
	    // Ruta de la plantilla que se usará para mostrar un mensaje de Twitter en un artículo noticia
	    TemplateTwitter: null,
	    // Id de la capa del elemento HTML que incluirá en su interior cada uno de los mensajes
	    HTMLElementId: "",
	    // Posición del módulo en la página (AB, B, C)
	    ColumnLocation: "C",
	    // Medio
	    Medio: "",
	    // Edición local
	    Edicion: "",
	    Scribble_API: "",
	    UrlPaginaDetalle: "",
	    PageNumber: 'last'
	  };
	
	  // Inicializa los parámetros de la función
	  for (var opt in Opciones) {
	    if (Opciones.hasOwnProperty(opt)) {
	      this.Opciones[opt] = Opciones[opt];
	    }
	  }
	
	  // Número de mensajes a mostrar
	  if (this.Opciones.TotalPostsToShow == "" || isNaN(this.Opciones.TotalPostsToShow)) {
	    this.Opciones.TotalPostsToShow = 10;
	  }
	  if (this.Opciones.TotalPostsToShow > 100 && this.Opciones.ColumnLocation != "AB") {
	    this.Opciones.TotalPostsToShow = 50;
	  }
	
	  // Tiempo mínimo (en segundos) de recarga del contenido
	  if (this.Opciones.AutoUpdateTimeOut < 10) {
	    this.Opciones.AutoUpdateTimeOut = 10;
	  }
	
	  // Detiene cualquier posible llamada anterior al método
	  this.clearDelayFetch(Wait);
	
	  // Objeto XMLHttpRequest para los distintos navegadores
	  xmlHttp = getHTTPObject();
	
	  // Momento de última modificación
	  this.LastModifiedTime = "";
	
	  // User agent del dispositivo
	  this.DeviceAgent = navigator.userAgent.toLowerCase();
	
	  // Índice para los eventos múltiples del script
	
	  this.InstanceIndex = InvocaScribbleLive.StoreInstance(this);
	
	  instanceIndex = this.InstanceIndex;
	
	  // Array con los elementos originales
	  this.originales = new Array();
	
	  // Array con los elementos JSON a mostrar
	  this.elementos = new Array();
	
	  // Array con los mensajes fijos
	  this.fijos = new Array();
	
	  // Obtiene el contenido de la plantilla
	  this.TemplateData = this.Opciones.Template;
	
	  // Plantilla de Twitter para el artículo noticia
	  this.TemplateTwitter = this.Opciones.TemplateTwitter;
	  if (this.TemplateTwitter != null) {
	    this.TemplateTwitter = this.Opciones.TemplateTwitter;
	  }
	
	  // Indica que se trata de la carga inicial
	  this.inicial = true;
	
	  // Obtiene los mensajes más recientes. Esta llamada solo se hace la primera vez que se carga el módulo
	  this.GetAllPosts();
	}
	
	// Índice
	InvocaScribbleLive.Index = 0;
	
	// The function that decides which instance of the recent posts object is currently being used.
	InvocaScribbleLive.GetInstance = function (pIndex) {
	
	  if (InvocaScribbleLive.__instances == undefined) {
	    return undefined;
	  } else {
	    return InvocaScribbleLive.__instances["" + pIndex];
	  }
	};
	
	// The function that sets the instance of the recent posts object.
	InvocaScribbleLive.StoreInstance = function (pInvocaScribbleLiveInstance) {
	
	  if (InvocaScribbleLive.__instances == undefined) {
	    InvocaScribbleLive.__instances = [];
	  }
	
	  var _Index = InvocaScribbleLive.Index;
	  InvocaScribbleLive.Index++;
	
	  InvocaScribbleLive.__instances[_Index] = pInvocaScribbleLiveInstance;
	
	  return _Index;
	};
	
	// Aquí se muestran los post obtenidos de la llamada recursiva
	InvocaScribbleLive.prototype.DrawPosts = function (pResponse) {
	  // Array de comprobación de mensajes "editados" que son realmente mensajes nuevos
	  var insertadosDesdeEdicion = new Array();
	  var addedNewPosts = false;
	  var newPostsCount = 0;
	  if (!this.inicial) {
	
	    if (pResponse.Edits != undefined) {
	      // Obtiene el máximo Id que se muestra actualmente, es decir, el id del mensaje más reciente
	      var maxId = 0;
	      try {
	        for (var mi = 0; mi < this.elementos.length; mi++) {
	          if (maxId < parseInt(this.elementos[mi].Id)) {
	            maxId = parseInt(this.elementos[mi].Id);
	          }
	        }
	      } catch (e) {}
	      for (var ed = 0; ed < pResponse.Edits.length; ed++) {
	        // Si el Id del mensaje editado es superior al Id más reciente acumulado hasta el momento
	        // indica que se trata de un nuevo post posiblemente con origen sindicado
	        if (parseInt(pResponse.Edits[ed].Id) > maxId) {
	          insertadosDesdeEdicion.push(parseInt(pResponse.Edits[ed].Id));
	          // Se trata como un mensaje nuevo
	          addedNewPosts = this.AddPost(pResponse.Edits[ed]);
	        }
	      }
	    }
	  }
	
	  // Añade los nuevos elementos a la lista JSON
	  if (pResponse.Posts != undefined) {
	    for (var p = 0; p < pResponse.Posts.length; p++) {
	      addedNewPosts = this.AddPost(pResponse.Posts[p]);
	    }
	  }
	
	  // Actualiza los elementos editados si están en la lista a mostrar y no han sido ya modificados
	  var arrayEdicion = new Array();
	  var arrayFijosEdicion = new Array();
	  if (pResponse.Edits != undefined) {
	    for (var e = 0; e < pResponse.Edits.length; e++) {
	      // Se comprueba que el elemento no esté ya el array de insertados desde edición,
	      // en cuyo caso no hay nada que editar al tratarse de un mensaje nuevo
	      if ($.inArray(parseInt(pResponse.Edits[e].Id), insertadosDesdeEdicion) == -1) {
	        for (var b = 0; b < this.elementos.length; b++) {
	          pResponse.Edits[e].LastModified = pResponse.Edits[e].LastModified.replace(/\+0000/g, "");
	          var PostLastModified = eval("new " + pResponse.Edits[e].LastModified.replace(/\//g, ""));
	
	          if (pResponse.Edits[e].Id == parseInt(this.elementos[b].Id) && PostLastModified > this.LastModifiedTime) {
	            var arrayEdiciones = this.EditPost(pResponse.Edits[e]);
	            if (arrayEdiciones[0] > -1) {
	              arrayEdicion.push(arrayEdiciones[0]);
	            }
	            if (arrayEdiciones[1] > -1) {
	              arrayFijosEdicion.push(arrayEdiciones[1]);
	            }
	          }
	        }
	      }
	    }
	  }
	
	  // Si hay elementos eliminados comprueba que estén en la lista a mostrar y en tal caso los elimina
	  var eliminados = 0;
	  if (pResponse.Deletes != undefined) {
	    for (var d = 0; d < pResponse.Deletes.length; d++) {
	      for (var a = 0; a < this.elementos.length; a++) {
	        if (pResponse.Deletes[d].Id == parseInt(this.elementos[a].Id)) {
	          var eliminado = this.DeletePost(pResponse.Deletes[d].Id);
	          if (eliminado) {
	            eliminados++;
	          }
	        }
	      }
	    }
	  }
	
	  // Copia con los elementos originales
	  if (this.inicial) {
	    this.originales = this.elementos.slice();
	  }
	
	  // Elimina los elementos sobrantes
	  if (tipoEspecial != "elecciones-2015" || !isArticulo) {
	    while (this.elementos.length > this.Opciones.TotalPostsToShow) {
	      this.elementos.pop();
	    }
	  }
	
	  // Rehace el array de elementos si ha habido alguna eliminación
	  if (tipoEspecial != "elecciones-2015" || !isArticulo) {
	    if (!this.inicial && this.elementos.length < this.Opciones.TotalPostsToShow && this.originales.length >= this.Opciones.TotalPostsToShow) {
	      for (var i = this.elementos.length; this.elementos.length < this.Opciones.TotalPostsToShow; i++) {
	        this.elementos.push(this.originales[i]);
	      }
	    }
	  }
	
	  // Obtiene el momento de última modificación del evento
	  pResponse.LastModified = pResponse.LastModified.replace(/\+0000/g, ""); //octal literales forbidden in scrict mode
	  this.LastModifiedTime = eval("new " + pResponse.LastModified.replace(/\//g, ""));
	
	  // Última página. Se le resta uno pues en realidad da la longitud de páginas, no la última (el muy gilipollas)
	  lastPage = pResponse.Pages - 1;
	  if (this.inicial) {
	    pageToGet = lastPage - 1;
	    if (pageToGet < 0) {
	      pageToGet = 0;
	    }
	  }
	
	  // Se formatea cada uno de elementos del JSON
	  this.EditJsonElement(pResponse);
	
	  // Divs actuales de la página
	  var divs = document.getElementsByTagName('div');
	  var divsArray = new Array();
	
	  // Busca el primero div de la serie anterior de mensajes (solo lo encontrará si no es la primera carga), es decir, el mensaje más reciente hasta el momento
	  var primerIdAntiguo = null;
	  // Filtra solo los div de ScribbleLive y añade nuevos div con los nuevos mensajes
	  for (var i = 0; i < divs.length; i++) {
	    if (divs[i].id.indexOf(this.Opciones.HTMLElementId) > -1) {
	      divsArray.push(divs[i]);
	      if (!this.inicial && primerIdAntiguo == null) {
	        primerIdAntiguo = divs[i].id;
	      }
	    }
	  }
	
	  var pintados = 0;
	  for (var i = 0; i < this.elementos.length; i++) {
	    var contiene = false;
	    for (var j = 0; j < divsArray.length; j++) {
	      // Comprueba si el div ya está incluido en la página
	      if (divsArray[j].id == this.Opciones.HTMLElementId + "-" + this.elementos[i].Id) {
	        contiene = true;
	        break;
	      }
	    }
	    // Si el div no está incluido se pinta en la página
	    if (!contiene) {
	      var capa = document.createElement('div');
	      capa.id = this.Opciones.HTMLElementId + "-" + this.elementos[i].Id;
	      if (isTwitterPost(this.elementos[i], this.TemplateTwitter)) {
	        capa.innerHTML = this.TemplateTwitter;
	      } else {
	        capa.innerHTML = this.TemplateData;
	      }
	      if (primerIdAntiguo != null) {
	        if (eliminados > 0) {
	          if ($(".mCSB_container").length) {
	            $(".mCSB_container").append(capa);
	          } else {
	            $("#" + this.Opciones.PageElementId).append(capa);
	          }
	          eliminados--;
	        } else {
	          newPostsCount++;
	          $(capa).insertBefore($("#" + primerIdAntiguo));
	        }
	      } else {
	        // Si es la carga inicial añade el elemento al final
	        document.getElementById(this.Opciones.PageElementId).appendChild(capa);
	      }
	
	      // Render vía tempo del mensaje
	      this.tempoRender(capa, { escape: false }, this.elementos[i]);
	      pintados++;
	    }
	    // Si hay que editar el post se actualiza la capa
	    if (arrayEdicion.length > 0) {
	      for (var k = 0; k < arrayEdicion.length; k++) {
	        if (i == arrayEdicion[k]) {
	          var id = this.Opciones.HTMLElementId + "-" + this.elementos[i].Id;
	          var capa = document.getElementById(id);
	          if (isTwitterPost(this.elementos[i], this.TemplateTwitter)) {
	            capa.innerHTML = this.TemplateTwitter;
	          } else {
	            capa.innerHTML = this.TemplateData;
	          }
	          try {
	            document.getElementById(this.Opciones.PageElementId).replaceChild(capa, document.getElementById(id));
	          } catch (errorEdit) {}
	          this.tempoRender(capa, { escape: false }, this.elementos[i]);
	          break;
	        }
	      }
	    }
	  }
	
	  if (!this.inicial) {
	    // Elimina los posibles elementos sobrantes (post antiguos)
	    for (var i = 0; i < divsArray.length; i++) {
	      var contiene = false;
	      for (var j = 0; j < this.elementos.length; j++) {
	        var id = this.Opciones.HTMLElementId + "-" + this.elementos[j].Id;
	        if (divsArray[i].id == id) {
	          contiene = true;
	          break;
	        }
	      }
	      if (!contiene) {
	        $("#" + divsArray[i].id).remove();
	      }
	    }
	
	    // Posiciona los mensajes fijos en los primeros lugares
	    var stuckPosition = 0;
	    for (var i = 0; i < this.fijos.length; i++) {
	      // Id del elemento a reemplazar. Ha de ser no fijo
	      var toBeReplacedId = null;
	      for (var j = 0; j < this.elementos.length; j++) {
	        if (this.elementos[j].IsStuck != 1) {
	          toBeReplacedId = this.Opciones.HTMLElementId + "-" + this.elementos[j].Id;
	          break;
	        }
	      }
	      if (toBeReplacedId != null) {
	        // Id del elemento fijo
	        var stuckedId = this.Opciones.HTMLElementId + "-" + this.fijos[i].Id;
	        // Mueve el elemento fijo a la posición indicada por stuckPosition, siempre y cuando no sea la posición que ya ocupaba previamente
	        if (toBeReplacedId != stuckedId && $("#" + toBeReplacedId).isBefore($("#" + stuckedId))) {
	          // Borra el elemento fijo de su antigua posición
	          if (document.getElementById(stuckedId)) {
	            $("#" + stuckedId).remove();
	          }
	          // Capa con el mensaje
	          var capa = document.createElement('div');
	          capa.id = stuckedId;
	          if (isTwitterPost(this.fijos[i], this.TemplateTwitter)) {
	            capa.innerHTML = this.TemplateTwitter;
	          } else {
	            capa.innerHTML = this.TemplateData;
	          }
	          // Inserta el elemento fijo en la posición stuckPosition
	          $(capa).insertBefore($("#" + toBeReplacedId));
	          this.tempoRender(capa, { escape: false }, this.fijos[i]);
	        }
	        stuckPosition++;
	      }
	      // Elementos fijos editados
	      for (var k = 0; k < arrayFijosEdicion.length; k++) {
	        if (i == arrayFijosEdicion[k]) {
	          var id = stuckedId;
	          var capa = document.getElementById(id);
	          if (isTwitterPost(this.fijos[i], this.TemplateTwitter)) {
	            capa.innerHTML = this.TemplateTwitter;
	          } else {
	            capa.innerHTML = this.TemplateData;
	          }
	          document.getElementById(this.Opciones.PageElementId).replaceChild(capa, document.getElementById(id));
	
	          this.tempoRender(capa, { escape: false }, this.fijos[i]);
	          break;
	        }
	      }
	    }
	  }
	
	  // Mensajes más nuevos
	  lastMessages = false;
	
	  // Llamada repetitiva para obtener nuevos mensajes
	  this.setRetryFetch();
	
	  if (window.twttr) {
	    window.twttr.widgets.load();
	  }
	
	  if (this.inicial || addedNewPosts) {
	    //Refrescamos video-player para que funcione
	    Voonto.getInstance().trigger('videoplayer:refresh', [$('.voc-live-scribble')]);
	    Voonto.getInstance().trigger('videoplayer:refresh', [$('.voc-live-module')]);
	  }
	
	  this.inicial ? this.triggerFullItemsRendered() : this.triggerFullItemsRendered(newPostsCount);
	
	  this.inicial = false;
	};
	
	InvocaScribbleLive.prototype.triggerFullItemsRendered = function (itemsCount) {
	  var _this = this;
	
	  window.setTimeout(function () {
	    if (itemsCount) {
	      window.Voonto.getInstance().trigger('scribblelive:updated', [_this.Opciones.container$.children().slice(0, itemsCount).get()]);
	    } else {
	      window.Voonto.getInstance().promised('scribblelive:ready', _this.Opciones.container$.get(0));
	    }
	  }, 0);
	};
	
	InvocaScribbleLive.prototype.setRetryFetch = function (time) {
	  this.clearDelayFetch(this.Wait);
	  this.Wait = this.setDelayFetch(time);
	};
	
	InvocaScribbleLive.prototype.setDelayFetch = function (time) {
	  var _this2 = this;
	
	  this.Wait = setTimeout(function () {
	    InvocaScribbleLive.GetInstance(_this2.InstanceIndex).GetNewPosts();
	  }, (time || this.Opciones.AutoUpdateTimeOut) * 1000);
	  return this.Wait;
	};
	
	InvocaScribbleLive.prototype.clearDelayFetch = function (clearId) {
	  clearTimeout(clearId || this.Wait);
	};
	
	// Muestra los post antiguos
	InvocaScribbleLive.prototype.DrawOldPosts = function (pResponse) {
	
	  // Si no obtiene nada no sigue la ejecución
	  if (pResponse.Posts.length == 0) {
	    $("#SL_loadingPages").hide();
	    return;
	  }
	
	  // Añade los nuevos elementos a la lista JSON
	  if (pResponse.Posts != undefined) {
	    for (var p = 0; p < pResponse.Posts.length; p++) {
	      this.AddPost(pResponse.Posts[p]);
	    }
	  }
	
	  // Se formatea cada uno de elementos del JSON
	  this.EditJsonElement(pResponse);
	
	  // Divs actuales de la página
	  var divs = document.getElementsByTagName('div');
	  var divsArray = new Array();
	  var ultimoIdAntiguo = null;
	  // Filtra solo los div de ScribbleLive y añade nuevos div con los nuevos mensajes
	  for (var i = 0; i < divs.length; i++) {
	    if (divs[i].id.indexOf(this.Opciones.HTMLElementId) > -1) {
	      divsArray.push(divs[i]);
	    }
	  }
	  ultimoIdAntiguo = divsArray[divsArray.length - 1].id;
	
	  for (var i = 0; i < this.elementos.length; i++) {
	    var contiene = false;
	    for (var j = 0; j < divsArray.length; j++) {
	      // Comprueba si el div ya está incluido en la página
	      if (divsArray[j].id == this.Opciones.HTMLElementId + "-" + this.elementos[i].Id) {
	        contiene = true;
	        break;
	      }
	    }
	    // Si el div no está incluido se pinta en la página
	    if (!contiene) {
	      var capa = document.createElement('div');
	      capa.id = this.Opciones.HTMLElementId + "-" + this.elementos[i].Id;
	      if (isTwitterPost(this.elementos[i], this.TemplateTwitter)) {
	        capa.innerHTML = this.TemplateTwitter;
	      } else {
	        capa.innerHTML = this.TemplateData;
	      }
	      $(capa).insertAfter($("#" + ultimoIdAntiguo));
	      // Render vía tempo del mensaje
	      this.tempoRender(capa, { escape: false }, this.elementos[i]);
	    }
	  }
	
	  this.triggerFullItemsRendered();
	
	  $("#SL_loadingPages").hide();
	};
	
	InvocaScribbleLive.prototype.tempoRender = function (capa, scape, elemento) {
	  _tempo2.default.prepare(capa, scape).when('render_complete', function (_ref3) {
	    var type = _ref3.type,
	        element = _ref3.element;
	
	    window.Voonto.getInstance().trigger('scribblelive:item-rendered', element);
	  }).render(elemento);
	};
	
	// Obtiene el caption (pie) de un elemento
	InvocaScribbleLive.prototype.GetCaption = function (Content) {
	  var caption = "";
	  if (Content.indexOf("p class=\"Caption\"") > -1) {
	    try {
	      var m = /<p class="Caption">(.*?)<\/p>/g.exec(Content);
	      if (m != null) {
	        caption = m[1];
	      }
	    } catch (e) {}
	  }
	  if (Content.indexOf("figcaption") > -1) {
	    try {
	      var m = /<figcaption(.*?)>(.*?)<\/figcaption>/g.exec(Content);
	      if (m != null) {
	        caption = m[2];
	      }
	    } catch (e) {}
	  }
	  return caption;
	};
	
	// Formatea un mensaje con un vídeo de Brightcove para invocar al player interno. El mensaje será del estilo ##[ID_DE_REFERENCIA]##
	InvocaScribbleLive.prototype.FormatVideoPlayer = function (Content) {
	
	  var videoId;
	  var origenVideo = "bc";
	  var maBC = null;
	  if (Content.indexOf("<iframe") > -1 && Content.indexOf("youtube.com") > -1) {
	    // Vídeo de YouTube
	    var inicio = Content.indexOf("src=") + 5;
	    var videoPlayer = Content.substring(inicio, Content.indexOf("\"", inicio));
	    if (videoPlayer.indexOf("?") > -1) {
	      videoPlayer = videoPlayer.substring(0, videoPlayer.indexOf("?"));
	    }
	    videoId = videoPlayer.substring(videoPlayer.lastIndexOf("/") + 1, videoPlayer.length);
	    origenVideo = "youtube";
	  } else {
	    // Transforma el id de ##[ID_DE_REFERENCIA]## a ID_DE_REFERENCIA
	    maBC = reBC.exec(Content);
	    videoId = maBC[0].replace(/#/g, '');
	    videoId = videoId.replace(/<small>/g, '');
	    videoId = videoId.replace(/<\/small>/g, '');
	  }
	
	  var modal = true;
	  var width = 150;
	  if (this.Opciones.ColumnLocation == "AB") {
	    width = 490;
	    modal = false;
	  }
	  if (this.Opciones.ColumnLocation == "C") {
	    if (tipoEspecial == "elecciones-2015") {
	      width = 190;
	    } else {
	      width = 280;
	    }
	  }
	
	  // Proporción 16:9
	  var height = parseInt(width / 1.77777777);
	  var brDiv = "";
	  var brCall = "";
	  // Capa donde se pintará el vídeo
	  if (origenVideo != 'bc') {
	    var media = Voonto.getInstance().lookup('vocento.site.media');
	    brDiv += "<article><figure class='voc-figure-icon'> ";
	    brDiv += "<a class='voc-horizontal voc-img-icon-link'>";
	    brDiv += "<div class=\"video-player\" ";
	    brDiv += "data-voc-video-player ";
	    brDiv += "data-voc-video-player-accountname=\"" + media + "\" ";
	    brDiv += "data-voc-video-player-source=\"youtube\" ";
	    brDiv += "data-voc-video-player-videoid=\"" + videoId + "\" ";
	    brDiv += "data-voc-video-player-autoplay=\"false\">";
	    brDiv += "</div>";
	    brDiv += "<i class=\"voc-icons videobig voc-multimedia-box voc-ico-m voc-literal \"> <span>2:10</span> </i>";
	    brDiv += "</a>";
	    brDiv += "</figure></article> ";
	  } else {
	    var media = Voonto.getInstance().lookup('vocento.site.media');
	    brDiv += "<article><figure class='voc-figure-icon'> ";
	    brDiv += "<a class='voc-horizontal voc-img-icon-link'>";
	    brDiv += "<div class=\"video-player\" ";
	    brDiv += "data-voc-video-player ";
	    brDiv += "data-voc-video-player-accountname=\"" + media + "\" ";
	    brDiv += "data-voc-video-player-source=\"brightcove\" ";
	    brDiv += "data-voc-video-player-videoid=\"" + videoId + "\" ";
	    brDiv += "data-voc-video-player-autoplay=\"false\">";
	    brDiv += "</div>";
	    brDiv += "<i class=\"voc-icons videobig voc-multimedia-box voc-ico-m voc-literal \"> <span>2:10</span> </i>";
	    brDiv += "</a>";
	    brDiv += "</figure></article> ";
	  }
	
	  var contenido;
	  if (maBC) {
	    contenido = Content.replace(reBC, brDiv);
	  } else {
	    contenido = Content.replace(/<iframe(.*?)<\/iframe>/g, brDiv);
	  }
	
	  return [contenido, brCall];
	};
	
	// Formatea un mensaje con un vídeo de Brightcove contenido dentro de un object para invocar al player interno
	InvocaScribbleLive.prototype.FormatVideoObject = function (Content) {
	
	  var start = Content.indexOf("<object id");
	  var end = Content.indexOf("</object>") + 9;
	  // Id del vídeo (videoPlayer=X)
	  var videoPlayer = Content.substring(Content.indexOf("videoPlayer=") + 12, Content.indexOf("&", Content.indexOf("videoPlayer=")));
	  if (isNaN(videoPlayer)) {
	    // Busca de forma alternativa por (videoId=X)
	    videoPlayer = Content.substring(Content.indexOf("videoId=") + 8, Content.indexOf("&", Content.indexOf("videoId=")));
	    if (isNaN(videoPlayer)) {
	      return [Content, ""];
	    }
	  }
	
	  var width = 150;
	  if (this.Opciones.ColumnLocation == "AB") {
	    width = 490;
	  }
	  if (this.Opciones.ColumnLocation == "C") {
	    if (tipoEspecial == "elecciones-2015") {
	      width = 190;
	    } else {
	      width = 280;
	    }
	  }
	  // Proporción 16:9
	  var height = parseInt(width / 1.77777777);
	
	  // Capa donde se pintará el vídeo
	  var brDiv = "<div id=\"video_scribblelive_" + videoPlayer + "\"></div>";
	  // Llamada al JS
	  //TODO Hacer la llamada al js necesario para videos que no sean youtube
	  var brCall = "";
	
	  var media = Voonto.getInstance().lookup('vocento.site.media');
	  brDiv += "<article><figure class='voc-figure-icon'> ";
	  brDiv += "<a class='voc-horizontal voc-img-icon-link'>";
	  brDiv += "<div class=\"video-player\" ";
	  brDiv += "data-voc-video-player ";
	  brDiv += "data-voc-video-player-accountname=\"" + media + "\" ";
	  brDiv += "data-voc-video-player-source=\"brightcove\" ";
	  brDiv += "data-voc-video-player-videoid=\"" + videoPlayer + "\" ";
	  brDiv += "data-voc-video-player-autoplay=\"false\">";
	  brDiv += "<i class=\"voc-icons videobig voc-multimedia-box voc-ico-m voc-literal \"> <span>2:10</span> </i>";
	  brDiv += "</div>";
	  brDiv += "</a>";
	  brDiv += "</figure> ";
	
	  return [Content.substring(0, start) + brDiv + Content.substring(end, Content.lentgh), brCall];
	};
	
	// Reescala un iframe para que encaje en el módulo
	InvocaScribbleLive.prototype.ResizeIframe = function (Content) {
	
	  var regWidth = new RegExp(/(width=)('|\")(\d+)('|\")/);
	  var regHeight = new RegExp(/(height=)('|\")(\d+)('|\")/);
	  try {
	    var width = regWidth.exec(Content)[3];
	    var height = regHeight.exec(Content)[3];
	    // Proporción de reducción
	    var maxWidth = 280;
	    if (this.Opciones.ColumnLocation == "AB") {
	      maxWidth = 615;
	    }
	    if (this.Opciones.ColumnLocation == "C" && tipoEspecial == "elecciones-2015") {
	      maxWidth = 190;
	    }
	    var proportion = 1.0;
	    if (width > maxWidth) {
	      proportion = width / maxWidth;
	      width = parseInt(width / proportion);
	      height = parseInt(height / proportion);
	    }
	    Content = Content.replace(regWidth, '$1$2' + width + '$4');
	    Content = Content.replace(regHeight, '$1$2' + height + '$4');
	  } catch (err) {}
	
	  return Content;
	};
	
	// Tamaño de la imagen para el resizer
	InvocaScribbleLive.prototype.ResizeImageWidth = function () {
	  var newWidth = 280;
	  if (this.Opciones.ColumnLocation == "C" && tipoEspecial == "elecciones-2015") {
	    maxWidth = 190;
	  }
	  if (this.Opciones.ShowAvatars == "true") {
	    newWidth = 200;
	  }
	  if (this.Opciones.ColumnLocation == "B") {
	    newWidth = newWidth - 55;
	  } else if (this.Opciones.ColumnLocation == "AB") {
	    newWidth = 615;
	  }
	  return newWidth;
	};
	
	// Redimensiona las imágenes
	InvocaScribbleLive.prototype.ResizeImage = function (Content) {
	  var re = new RegExp(/['"]/);
	  var start = Content.indexOf("<img ");
	  var newWidth = this.ResizeImageWidth();
	  while (start > -1) {
	    start = Content.indexOf("src=", start + 1);
	    if (start > -1) {
	      var end = re.exec(Content.substring(start + 5, Content.length));
	      var finalContent = Content.substring(start + 6 + end.index, Content.length);
	      var urlImagen = Content.substring(start + 5, start + 5 + end.index);
	      var imagen = "src=\"" + urlImagen + "\"";
	      if (isUrlImagenInterna(urlImagen)) {
	        imagen = "src=\"" + getMediaResizerUrl() + "/resizer/resizer.php?imagen=" + urlImagen + "&nuevoancho=" + newWidth + "&copyright=conCopyright&encrypt=false\"";
	      }
	      Content = Content.substring(0, start) + imagen + finalContent;
	    }
	  }
	  return Content;
	};
	
	// Añade el elemento target="_blank" a los enlaces de un mensaje y el parámetro "medio" y "edicionLocal" a las llamadas a "live.vocento.com/scribblelive/redirect.php"
	InvocaScribbleLive.prototype.FormatLink = function (Content) {
	  // Expresión regular para sustituir la llamada al redirector de noticias de RC de ScribbleLive
	  var re = new RegExp("recid=([^\"'].*)(\">|'>)");
	  var start = Content.toLowerCase().indexOf("<a ");
	  while (start > -1) {
	    var end = Content.toLowerCase().indexOf("</a>", start);
	    if (end > -1) {
	      var link = Content.substring(start, end + 4);
	      // Comprueba si se trata de una llamada a "live.vocento.com/scribblelive/redirect.php"
	      if (link.indexOf("live.vocento.com/scribblelive/redirect.php?recid=") > -1 && link.indexOf("medio=") == -1) {
	        var parametrosLlamada = "&medio=" + this.Opciones.Medio;
	        if (this.Opciones.Edicion != null && this.Opciones.Edicion.replace(/\s/g, "") != "") {
	          parametrosLlamada = parametrosLlamada + "&edicionLocal=" + this.Opciones.Edicion;
	        }
	        link = link.replace(re, "recid=$1" + parametrosLlamada + "$2");
	        Content = Content.substring(0, start) + link + Content.substring(end + 4, Content.length);
	        // Recalcula la nueva posición del fin del tag <a>
	        end = Content.toLowerCase().indexOf("</a>", start);
	      }
	      // Añade target blank a los enlaces
	      if (link.toLowerCase().indexOf("target=") == -1 && link.toLowerCase().indexOf("href=") > -1) {
	        link = link.replace("href=", "target=\"_blank\" href=");
	        Content = Content.substring(0, start) + link + Content.substring(end + 4, Content.length);
	      }
	    }
	    start = Content.toLowerCase().indexOf("<a ", start + 1);
	  }
	  return Content;
	};
	
	// Redimensiona los object embed
	InvocaScribbleLive.prototype.ResizeEmbed = function (Content) {
	
	  if (this.Opciones.ColumnLocation == "AB") {
	    return Content;
	  }
	  var re = new RegExp(/['"]/);
	  // Ancho
	  var start = Content.indexOf("width=");
	  var newWidth = 280;
	  if (this.Opciones.ShowAvatars == "true") {
	    newWidth = 200;
	  }
	  if (this.Opciones.ColumnLocation == "B") {
	    newWidth = newWidth - 55;
	  }
	  while (start > -1) {
	    if (start > -1) {
	      var end = re.exec(Content.substring(start + 7, Content.length));
	      var finalContent = Content.substring(start + 8 + end.index, Content.length);
	      Content = Content.substring(0, start) + "width=\"" + newWidth + "\"" + finalContent;
	    }
	    start = Content.indexOf("width=", start + 1);
	  }
	  // Alto
	  start = Content.indexOf("height=");
	  while (start > -1) {
	    if (start > -1) {
	      var end = re.exec(Content.substring(start + 8, Content.length));
	      var finalContent = Content.substring(start + 9 + end.index, Content.length);
	      Content = Content.substring(0, start) + "height=\"180\"" + finalContent;
	    }
	    start = Content.indexOf("height=", start + 1);
	  }
	  return Content;
	};
	
	// The function that adds a post.
	InvocaScribbleLive.prototype.AddPost = function (pPost) {
	
	  // A huge if statement that decides if it should be showing a post or not based on the options set when the widget is loaded.
	  if (pPost.Type == "IMAGE" && !this.Opciones.ShowImages || pPost.Type == "VIDEO" && !this.Opciones.ShowVideos || pPost.Type == "AUDIO" && !this.Opciones.ShowAudio || pPost.IsStuck == 1 && !this.Opciones.ShowStuckPosts || pPost.Type == "TEXT" && !this.Opciones.ShowTextPosts || pPost.Type == "POLL" && !this.Opciones.ShowPolls || pPost.IsComment == 1 && !this.Opciones.ShowComments || pPost.IsComment == 0 && !this.Opciones.ShowOfficialPosts || pPost.Source.match("twitter") && !this.Opciones.ShowTweets || !pPost.Source.match("twitter") && this.Opciones.ShowOnlyTweets || (pPost.Source.match("mobile") || pPost.Source.match("SMS")) && !this.Opciones.ShowMobilePosts || pPost.Source.match("www.facebook.com") && !this.Opciones.ShowFacebookPosts || !pPost.Source.match("www.facebook.com") && this.Opciones.ShowOnlyFacebookPosts || pPost.Type != "POLL" && this.Opciones.ShowOnlyPolls) {
	    return false;
	  }
	
	  // If the post you are trying to add is already on the page, stop trying to add it.
	  for (var c = 0; c < this.elementos.length; c++) {
	    if (pPost.Id == parseInt(this.elementos[c].Id)) {
	      return false;
	    }
	  }
	
	  // Si se trata de la carga inicial inserta los elementos al final del array, en caso contrario inserta los nuevos elementos al inicio del array
	  if (this.inicial) {
	    this.elementos.push(pPost);
	  } else {
	    this.elementos.unshift(pPost);
	    this.originales.unshift(pPost);
	    return true;
	  }
	
	  // Elemento fijo
	  if (pPost.IsStuck == 1) {
	    this.fijos.unshift(pPost);
	    return true;
	  }
	};
	
	// Elimina el elemento del array y de la página
	InvocaScribbleLive.prototype.DeletePost = function (pPostId) {
	  for (var i = 0; i < this.originales.length; i++) {
	    if (parseInt(this.originales[i].Id) == parseInt(pPostId)) {
	      this.originales.splice(i, 1);
	    }
	  }
	  for (var i = 0; i < this.fijos.length; i++) {
	    if (parseInt(this.fijos[i].Id) == parseInt(pPostId)) {
	      this.fijos.splice(i, 1);
	    }
	  }
	  for (var i = 0; i < this.elementos.length; i++) {
	    if (parseInt(this.elementos[i].Id) == parseInt(pPostId)) {
	      this.elementos.splice(i, 1);
	      // Elimina el elemento de la página
	      $("#" + this.Opciones.HTMLElementId + "-" + pPostId).remove();
	      return true;
	    }
	  }
	  return false;
	};
	
	// Reemplaza el elemento editado del array
	InvocaScribbleLive.prototype.EditPost = function (pPostToEdit) {
	
	  for (var i = 0; i < this.originales.length; i++) {
	    if (parseInt(this.originales[i].Id) == parseInt(pPostToEdit.Id)) {
	      this.originales.splice(i, 1, pPostToEdit);
	    }
	  }
	  var stuckedPos = -1;
	  for (var i = 0; i < this.fijos.length; i++) {
	    if (parseInt(this.fijos[i].Id) == parseInt(pPostToEdit.Id)) {
	      if (pPostToEdit.IsStuck != 1) {
	        this.fijos.splice(i, 1);
	      } else {
	        this.fijos.splice(i, 1, pPostToEdit);
	        stuckedPos = i;
	      }
	    }
	  }
	  for (var i = 0; i < this.elementos.length; i++) {
	    if (parseInt(this.elementos[i].Id) == parseInt(pPostToEdit.Id)) {
	      this.elementos.splice(i, 1, pPostToEdit);
	      return [i, stuckedPos];
	    }
	  }
	  return [-1, -1];
	};
	
	InvocaScribbleLive.prototype.CapitalizeFirstLetter = function (string) {
	  return string.charAt(0).toUpperCase() + string.slice(1);
	};
	
	// Formatea cada uno de los elementos de JSON en función de su contenido
	InvocaScribbleLive.prototype.EditJsonElement = function (pResponse) {
	
	  // Elimina todos los elementos Posts del objeto JSON
	  pResponse.Posts.splice(0, pResponse.Posts.length);
	  // Hoy
	  var today = moment(Date.now()).format("YYYYMMDD");
	
	  // Añade los elementos Posts correctos al objeto JSON
	  for (var i = 0; i < this.elementos.length; i++) {
	    try {
	      this.elementos[i].LastModified = this.elementos[i].LastModified.replace(/\+0000/g, ""); //octal literales forbidden in scrict mode
	      var PostDate = eval("new " + this.elementos[i].LastModified.replace(/\//g, ""));
	
	      // Formato de fecha de un mensaje escrito a día de hoy
	      if (moment(PostDate).format("YYYYMMDD") == today) {
	        var duration = moment.duration(moment(Date.now()).diff(moment(PostDate)));
	
	        if (duration.asSeconds() < 60) {
	          this.elementos[i].FormattedDate = 'En este momento';
	        } else if (duration.asMinutes() < 60) {
	          this.elementos[i].FormattedDate = 'Hace ' + duration.minutes() + ' minutos';
	        } else if (duration.asMinutes() < 120) {
	          this.elementos[i].FormattedDate = 'Hace 1 hora';
	        } else if (duration.asMinutes() < 180) {
	          this.elementos[i].FormattedDate = 'Hace 2 horas';
	        } else {
	          this.elementos[i].FormattedDate = moment(PostDate).format("HH:mm");
	        }
	        // Formato de fecha de un mensaje antes del día de hoy
	      } else {
	        this.elementos[i].FormattedDate = moment(PostDate).format(this.Opciones.DateFormat);
	      }
	    } catch (e) {
	      this.elementos[i].FormattedDate = "-";
	    }
	
	    // Si sube un mensaje con una imagen y sin ningún texto puede ser que this.elementos[i].Content esté sin definir.
	    // En tal caso se le da un valor vacío para evitar posteriores errores
	    if (typeof this.elementos[i].Content == "undefined") {
	      this.elementos[i].Content = "";
	    }
	    // Avatars
	    this.elementos[i].ShowAvatars = this.Opciones.ShowAvatars;
	    // Vídeo de Brightcove
	    var brightcoveParsed = false;
	    if (this.elementos[i].Content.indexOf("<object id") > -1 && this.elementos[i].Content.indexOf("brightcove.com") > -1 && this.elementos[i].Content.indexOf("/object") > -1 && this.elementos[i].Content.indexOf("playerID=") > -1) {
	      var arrayBrightcove = this.FormatVideoObject(this.elementos[i].Content);
	      this.elementos[i].Content = arrayBrightcove[0];
	      if (arrayBrightcove[1] != "") {
	        eval(arrayBrightcove[1]);
	      }
	      brightcoveParsed = true;
	    }
	    // Vídeo de Brighcove según el modelo ##[ID_DE_REFERENCIA]##
	    if (reBC.test($.trim(this.elementos[i].Content)) || this.elementos[i].Content.indexOf("<iframe") > -1 && this.elementos[i].Content.indexOf("youtube.com") > -1) {
	      var arrayBrightcove = this.FormatVideoPlayer(this.elementos[i].Content);
	      this.elementos[i].Content = arrayBrightcove[0];
	      if (arrayBrightcove[1] != "") {
	        eval(arrayBrightcove[1]);
	      }
	    }
	    // Iframe (por ejemplo nuevos vídeos de Brightcove)
	    if (this.elementos[i].Content.indexOf("<iframe") > -1) {
	      this.elementos[i].Content = this.ResizeIframe(this.elementos[i].Content);
	    }
	    // Cualquier otro object excepto Brightcove
	    if (!brightcoveParsed && (this.elementos[i].Content.indexOf("<object") > -1 && this.elementos[i].Content.indexOf("/object") > -1 || this.elementos[i].Content.indexOf("<embed") > -1)) {
	      this.elementos[i].Content = this.ResizeEmbed(this.elementos[i].Content);
	    }
	    // Resizer
	    if (this.elementos[i].Content.indexOf("<img ") > -1) {
	      this.elementos[i].Content = this.ResizeImage(this.elementos[i].Content);
	    }
	    // Imágenes subidas desde el editor de SL
	    try {
	      var imgs = "";
	      var videos = "";
	      for (var medias = 0; medias < this.elementos[i].Media.length; medias++) {
	        if (this.elementos[i].Media[medias].Type == "IMAGE" && this.elementos[i].Media[medias].Url.length > 0) {
	          var srcImagen = this.elementos[i].Media[medias].Url;
	          if (isUrlImagenInterna(this.elementos[i].Media[medias].Url)) {
	            srcImagen = getMediaResizerUrl() + "/resizer/resizer.php?imagen=" + this.elementos[i].Media[medias].Url + "&nuevoancho=" + this.ResizeImageWidth() + "&copyright=conCopyright&encrypt=false";
	          }
	          var element_class = 'voc-horizontal';
	          if ($('[data-voc-scribblelive]').data('voc-scribblelive-template')) {
	            element_class = ''; /*Si se trata de content no tiene que tener esta clase*/
	          }
	          imgs += "<figure class=\"voc-live-scribble-signature\"> <a href=\"#\" class=\"" + element_class + "\"><img src=\"" + srcImagen + "\" alt=\"\"> </a> </figure>";
	        } else if (this.elementos[i].Media[medias].Type == "VIDEO" && this.elementos[i].Media[medias].Url.length > 0) {
	          var brightcoveVideoId = this.elementos[i].Content.match(/##([a-zA-Z0-9-\s_]{3,60})##/g);
	          if (!brightcoveVideoId) {
	            var videoWidth = "280";
	            if (tipoEspecial == "elecciones-2015") {
	              videoWidth = "190";
	            }
	            if (this.Opciones.ColumnLocation == "AB") {
	              videoWidth = "560";
	            }
	            var videoHeight = parseInt(videoWidth / 1.77777777);
	            videos = "<video width=\"" + videoWidth + "\" height=\"" + videoHeight + "\" controls><source src=\"" + this.elementos[i].Media[medias].Url + "\" type=\"video/mp4\"></video>";
	          } else {
	            var media = Voonto.getInstance().lookup('vocento.site.media');
	            videos = "<article><figure class='voc-figure-icon'> ";
	            videos += "<a class='voc-horizontal voc-img-icon-link'>";
	            videos += "<div class=\"video-player\" ";
	            videos += "data-voc-video-player ";
	            videos += "data-voc-video-player-accountname=\"" + media.name + "\" ";
	            videos += "data-voc-video-player-source=\"brightcove\" ";
	            videos += "data-voc-video-player-videoid=\"" + brightcoveVideoId.replace("#", "") + "\" ";
	            videos += "data-voc-video-player-autoplay=\"false\">";
	            videos += "</div>";
	            videos += "<i class=\"voc-icons videobig voc-multimedia-box voc-ico-m voc-literal \"> <span>2:10</span> </i>";
	            videos += "</a>";
	            videos += "</figure></article>";
	          }
	        }
	      }
	      // El vídeo es prioritario sobre la imagen
	      if (imgs.length > 0 && videos.length == 0) {
	        this.elementos[i].Content = imgs + "<p>" + this.elementos[i].Content + "</p>";
	      }
	      if (videos.length > 0) {
	        this.elementos[i].Content = videos + "<p>" + this.elementos[i].Content + "</p>";
	      }
	    } catch (erroreMedia) {}
	    // Enlaces
	    if (this.elementos[i].Content.indexOf("<a ") > -1) {
	      this.elementos[i].Content = this.FormatLink(this.elementos[i].Content);
	    }
	    // Mensaje de Twitter
	    if (this.elementos[i].PostMeta != null && this.elementos[i].PostMeta.source == "twitter") {
	      var screenName = /twitter\.com\/(#!\/)?([^\/?]+)/.exec(this.elementos[i].Source)[2];
	      this.elementos[i].TwScreenName = "<a href=\"https://www.twitter.com/" + screenName + "\" target=\"_blank\">@" + screenName + "</a>";
	      try {
	        this.elementos[i].TwDate = moment(new Date(this.elementos[i].PostMeta.CreationDate * 1000)).format('HH:mm - DD/MM/YYYY');
	      } catch (e) {}
	    }
	    // Twitter
	    if (this.elementos[i].Source != null && this.elementos[i].Source.match("twitter")) {
	      this.elementos[i].Content = "<div><blockquote class=\"twitter-tweet\">" + this.elementos[i].Source + "</blockquote></div>";
	      try {
	        this.elementos[i].TwDate = moment(new Date(this.elementos[i].PostMeta.CreationDate * 1000)).format('HH:mm - DD/MM/YYYY');
	      } catch (e) {}
	    }
	    // Redes sociales
	    if (tipoEspecial == "elecciones-2015" || tipoEspecial == "nuevo") {
	      this.elementos[i].FacebookShare = facebookShare(gUrlPaginaDetalle, gTituloPestana, this.elementos[i].Content, this.elementos[i].Id);
	      this.elementos[i].TwitterShare = twitterShare(gUrlPaginaDetalle, gTituloPestana, this.elementos[i].Content);
	    }
	    // Pie de foto
	    var caption = this.GetCaption(this.elementos[i].Content);
	    if (caption != "" && this.elementos[i].Content.indexOf("</figure>") > -1) {
	      var m = /<\/figure>(.*)/g.exec(this.elementos[i].Content);
	      if (m != null) {
	        this.elementos[i].Content = this.elementos[i].Content.replace(m[1], "<p>" + caption + "</p>" + m[1]);
	      }
	    }
	
	    // Se eliminan ciertos tags HTML
	    this.elementos[i].Content = this.elementos[i].Content.replace(/<p class="Caption">/g, "<p>");
	    this.elementos[i].Content = this.elementos[i].Content.replace(/<figcaption(.*)>(.*)<\/figcaption>/g, "");
	    this.elementos[i].Content = this.elementos[i].Content.replace(/<br>/g, "");
	    this.elementos[i].Content = this.elementos[i].Content.replace(/<br\/>/g, "");
	    this.elementos[i].Content = this.elementos[i].Content.replace(/<div>.{1}<\/div>/g, "");
	    this.elementos[i].Content = this.elementos[i].Content.replace(/<div>&nbsp;<\/div>/g, "");
	    this.elementos[i].Content = this.elementos[i].Content.replace(/<div>(.*)<\/div>/g, "$1");
	    // en luga de eliminar figure lo sustituimos con la clase y estilo correcto
	    var element_class = 'voc-horizontal';
	    if ($('[data-voc-scribblelive]').data('voc-scribblelive-template')) {
	      element_class = ''; /*Si se trata de content no tiene que tener esta clase*/
	    }
	    this.elementos[i].Content = this.elementos[i].Content.replace(/<figure>(.*)<\/figure>/g, "<figure class=\"voc-live-scribble-signature\"><a href=\"#\" class=\"" + element_class + "\">$1</a></figure>");
	
	    this.elementos[i].Link = "";
	    if (this.Opciones.UrlPaginaDetalle) {
	      this.elementos[i].Link = this.Opciones.UrlPaginaDetalle + "#scribbleContent-" + this.elementos[i].Id;
	    }
	
	    pResponse.Posts.push(this.elementos[i]);
	  }
	};
	
	// Llamada recurrente que se ejecuta cada cierto tiempo (marcado por AutoUpdateTimeOut)
	InvocaScribbleLive.prototype.GetNewPosts = function () {
	  var _this3 = this;
	
	  // Delete any API calls that are currently on the page.
	  var Scripts;
	  if (document.head) {
	    Scripts = document.head.getElementsByTagName("script");
	  } else {
	    Scripts = document.getElementsByTagName('head')[0].getElementsByTagName("script");
	  }
	  for (var i = 0; i < Scripts.length; i++) {
	    var ScriptSource = Scripts[i].src;
	    if (ScriptSource.match(this.Opciones.Scribble_API + "/event/" + this.Opciones.EventId + ".*") != null) {
	      if (document.head) {
	        document.head.removeChild(Scripts[i]);
	      } else {
	        document.getElementsByTagName('head')[0].removeChild(Scripts[i]);
	      }
	    }
	  }
	
	  var LastModifiedTimeFormatted = this.LastModifiedTime.getUTCFullYear() + "/" + (this.LastModifiedTime.getUTCMonth() + 1) + "/" + this.LastModifiedTime.getUTCDate() + " " + this.LastModifiedTime.getUTCHours() + ":" + this.LastModifiedTime.getUTCMinutes() + ":" + this.LastModifiedTime.getUTCSeconds();
	
	  var url = this.Opciones.Scribble_API + "/event/" + this.Opciones.EventId + "/all/?Token=" + this.Opciones.APIToken + "&Order=asc&format=json&Since=" + LastModifiedTimeFormatted;
	  $.get(url, function (res) {
	    if (res) {
	      var hasChanges = res.Posts && res.Posts.length || res.Edits && res.Edits.length || res.Deletes && res.Deletes.length;
	
	      if (hasChanges) {
	        InvocaScribbleLive.GetInstance(_this3.InstanceIndex).DrawPosts(res);
	      }
	    }
	
	    _this3.setRetryFetch();
	  });
	};
	
	// Esta llamada solo se hace la primera vez que se carga el módulo. Obtiene los últimos mensajes ordenados de más nuevo a más antiguo
	InvocaScribbleLive.prototype.GetAllPosts = function () {
	  var _this4 = this;
	
	  var url = this.Opciones.Scribble_API + "/event/" + this.Opciones.EventId + "/page/" + this.Opciones.PageNumber + "/?Token=" + this.Opciones.APIToken + "&PageSize=" + this.Opciones.TotalPostsToShow + "&Order=asc&format=json&IncludeDeleted=0";
	
	  $.get(url, function (res) {
	    InvocaScribbleLive.GetInstance(_this4.InstanceIndex).DrawPosts(res);
	  });
	};
	
	// Llamada para obtener las páginas antiguas (paginación hacia atrás)
	InvocaScribbleLive.prototype.GetOldPosts = function () {
	  var _this5 = this;
	
	  // Delete any API calls that are currently on the page.
	  var Scripts;
	  if (document.head) {
	    Scripts = document.head.getElementsByTagName("script");
	  } else {
	    Scripts = document.getElementsByTagName('head')[0].getElementsByTagName("script");
	  }
	  for (var i = 0; i < Scripts.length; i++) {
	    var ScriptSource = Scripts[i].src;
	    if (ScriptSource.match(this.Opciones.Scribble_API + "/event/" + this.Opciones.EventId + ".*") != null) {
	      if (document.head) {
	        document.head.removeChild(Scripts[i]);
	      } else {
	        document.getElementsByTagName('head')[0].removeChild(Scripts[i]);
	      }
	    }
	  }
	
	  var url = this.Opciones.Scribble_API + "/event/" + this.Opciones.EventId + "/page/" + pageToGet + "/?Token=" + this.Opciones.APIToken + "&PageSize=" + this.Opciones.TotalPostsToShow + "&Order=desc&format=json&IncludeDeleted=0";
	  $.get(url, function (res) {
	    InvocaScribbleLive.GetInstance(_this5.InstanceIndex).DrawOldPosts(res);
	  });
	
	  // Se resta uno a la última página a mostrar para posteriores llamadas
	  pageToGet--;
	};

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * Tempo Template Engine 2.1
	 *
	 * http://tempojs.com/
	 */
	function TempoEvent(type, item, element) {
	    'use strict';
	
	    this.type = type;
	    this.item = item;
	    this.element = element;
	
	    return this;
	}
	
	TempoEvent.Types = {
	    RENDER_STARTING: 'render_starting',
	    ITEM_RENDER_STARTING: 'item_render_starting',
	    ITEM_RENDER_COMPLETE: 'item_render_complete',
	    RENDER_COMPLETE: 'render_complete',
	    BEFORE_CLEAR: 'before_clear',
	    AFTER_CLEAR: 'after_clear'
	};
	
	var Tempo = function (tempo) {
	    'use strict';
	
	    /*!
	     * Constants
	     */
	
	    var NUMBER_FORMAT_REGEX = /(\d+)(\d{3})/;
	
	    var _window;
	
	    /*!
	     * Helpers
	     */
	    var utils = {
	        memberRegex: function memberRegex(obj) {
	            var member_regex = '(';
	            for (var member in obj) {
	                if (obj.hasOwnProperty(member)) {
	                    if (member_regex.length > 1) {
	                        member_regex += '|';
	                    }
	                    member_regex += member;
	                }
	            }
	            return member_regex + ')[\\.]?' + '(?!\\w)';
	        },
	
	        pad: function pad(val, _pad, size) {
	            while (val.length < size) {
	                val = _pad + val;
	            }
	            return val;
	        },
	
	        trim: function trim(str) {
	            return str.replace(/^\s*([\S\s]*?)\s*$/, '$1');
	        },
	
	        startsWith: function startsWith(str, prefix) {
	            return str.indexOf(prefix) === 0;
	        },
	
	        clearContainer: function clearContainer(el) {
	            if (el !== null && el !== undefined && el.childNodes !== undefined) {
	                for (var i = el.childNodes.length - 1; i >= 0; i--) {
	                    if (el.childNodes[i] !== undefined && el.childNodes[i].getAttribute !== undefined && (el.childNodes[i].getAttribute('data-template') !== null || el.childNodes[i].getAttribute('data-template-for') !== null)) {
	                        el.childNodes[i].parentNode.removeChild(el.childNodes[i]);
	                    }
	                }
	            }
	        },
	
	        isNested: function isNested(el) {
	            var p = el.parentNode;
	            while (p) {
	                if (this.hasAttr(p, 'data-template') || this.hasAttr(p, 'data-template-for')) {
	                    return true;
	                }
	                p = p.parentNode;
	            }
	            return false;
	        },
	
	        equalsIgnoreCase: function equalsIgnoreCase(str1, str2) {
	            return str1.toLowerCase() === str2.toLowerCase();
	        },
	
	        getElement: function getElement(template, html) {
	            if (navigator.appVersion.indexOf("MSIE") > -1 && utils.equalsIgnoreCase(template.tagName, 'tr')) {
	                // Wrapping to get around read-only innerHTML
	                var el = _window.document.createElement('div');
	                el.innerHTML = '<table><tbody>' + html + '</tbody></table>';
	                var depth = 3;
	                while (depth--) {
	                    el = el.lastChild;
	                }
	                el.setAttribute('data-template', '');
	                return el;
	            } else {
	                // No need to wrap
	                template.innerHTML = html;
	                return template;
	            }
	        },
	
	        typeOf: function typeOf(obj) {
	            if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === "object") {
	                if (obj === null) {
	                    return "null";
	                }
	                if (obj.constructor === [].constructor) {
	                    return "array";
	                }
	                if (obj.constructor === new Date().constructor) {
	                    return "date";
	                }
	                if (obj.constructor === new RegExp().constructor) {
	                    return "regex";
	                }
	                if ((typeof HTMLElement === 'undefined' ? 'undefined' : _typeof(HTMLElement)) === "object" ? obj instanceof HTMLElement : obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === "object" && obj.nodeType === 1 && typeof obj.nodeName === "string") {
	                    return 'element';
	                }
	                if (typeof jQuery !== 'undefined' && obj instanceof jQuery) {
	                    return 'jquery';
	                }
	                return "object";
	            }
	            return typeof obj === 'undefined' ? 'undefined' : _typeof(obj);
	        },
	
	        hasAttr: function hasAttr(el, name) {
	            if (el !== undefined) {
	                if (el.hasAttribute !== undefined) {
	                    return el.hasAttribute(name);
	                } else if (el.getAttribute !== undefined) {
	                    return el.getAttribute(name) !== null;
	                }
	            }
	
	            return false;
	        },
	
	        removeAttr: function removeAttr(el, name) {
	            if (el !== undefined) {
	                el.setAttribute(name, '');
	                //                if (el.removeAttribute) {
	                //                    el.removeAttribute(name);
	                //                }
	            }
	        },
	
	        merge: function merge(obj1, obj2) {
	            var obj3 = {};
	
	            for (var attr1 in obj1) {
	                if (obj1.hasOwnProperty(attr1)) {
	                    obj3[attr1] = obj1[attr1];
	                }
	            }
	
	            for (var attr2 in obj2) {
	                if (obj2.hasOwnProperty(attr2)) {
	                    obj3[attr2] = obj2[attr2];
	                }
	            }
	            return obj3;
	        },
	        notify: function notify(listener, event) {
	            if (listener !== undefined && listener.length > 0) {
	                for (var i = 0; i < listener.length; i++) {
	                    if (event.type === listener[i].type) {
	                        listener[i].listener(event);
	                    }
	                }
	            }
	        },
	        container: function container(_container) {
	            if (utils.typeOf(_container) === 'string') {
	                if (_container === '*') {
	                    _container = _window.document.getElementsByTagName('html')[0];
	                } else {
	                    _container = _window.document.getElementById(_container);
	                }
	            } else if (utils.typeOf(_container) === 'jquery' && _container.length > 0) {
	                _container = _container[0];
	            }
	
	            return _container;
	        },
	        arrayContains: function arrayContains(array, obj) {
	            if (!Array.prototype.indexOf) {
	                for (var i = 0; i < this.length; i++) {
	                    if (this[i] === obj) {
	                        return true;
	                    }
	                }
	                return false;
	            } else {
	                return array.indexOf(obj) > -1;
	            }
	        }
	    };
	
	    function Templates(params, nestedItem) {
	        this.params = params;
	        this.defaultTemplate = null;
	        this.namedTemplates = {};
	        this.container = null;
	
	        this.nestedItem = nestedItem !== undefined ? nestedItem : null;
	
	        this.escape = true;
	        this.var_brace_left = '\\{\\{';
	        this.var_brace_right = '\\}\\}';
	        this.tag_brace_left = '\\{%';
	        this.tag_brace_right = '%\\}';
	
	        this.dataIsMap = false;
	
	        this.attributes = {};
	
	        if (typeof params !== 'undefined') {
	            for (var prop in params) {
	                if (prop === 'var_braces') {
	                    this.var_brace_left = params[prop].substring(0, params[prop].length / 2);
	                    this.var_brace_right = params[prop].substring(params[prop].length / 2);
	                } else if (prop === 'tag_braces') {
	                    this.tag_brace_left = params[prop].substring(0, params[prop].length / 2);
	                    this.tag_brace_right = params[prop].substring(params[prop].length / 2);
	                } else if (typeof this[prop] !== 'undefined') {
	                    this[prop] = params[prop];
	                }
	            }
	        }
	
	        return this;
	    }
	
	    Templates.prototype = {
	        load: function load(file, callback) {
	            function contents(iframe) {
	                return iframe.contentWindow ? iframe.contentWindow.document.documentElement.innerHTML : iframe.contentDocument ? iframe.contentDocument.body.innerHTML : iframe.document.body.innerHTML;
	            }
	
	            if (_window.document.getElementById(file) !== null) {
	                callback(contents(_window.document.getElementById(file)));
	            } else {
	                var el = _window.document.createElement('iframe');
	                el.id = file;
	                el.name = file;
	                el.style.height = 0;
	                el.style.width = 0;
	                el.src = file;
	
	                if (el.attachEvent) {
	                    el.attachEvent('onload', function () {
	                        callback(contents(el));
	                    });
	                } else {
	                    el.onload = function () {
	                        callback(contents(el));
	                    };
	                }
	
	                _window.document.body.appendChild(el);
	            }
	        },
	        _insertTemplate: function _insertTemplate(child, templates, container, callback) {
	            return function (el) {
	                utils.removeAttr(child, 'data-template-file');
	                child.innerHTML = el;
	                templates.parse(container, callback);
	            };
	        },
	
	        parse: function parse(container, callback) {
	            this.container = container;
	            var children = container.getElementsByTagName('*');
	
	            var ready = true;
	
	            // Preprocessing for referenced templates
	            for (var i = 0; i < children.length; i++) {
	                if (ready === true && callback !== undefined && utils.hasAttr(children[i], 'data-template-file')) {
	                    var child = children[i];
	                    if (child.getAttribute('data-template-file').length > 0) {
	                        var templates = this;
	                        ready = false;
	
	                        this.load(child.getAttribute('data-template-file'), this._insertTemplate(child, templates, container, callback));
	                    }
	                } else if (utils.hasAttr(children[i], 'data-template-fallback')) {
	                    // Hiding the fallback template
	                    children[i].style.display = 'none';
	                }
	            }
	
	            // Parsing
	            if (ready) {
	                var foundTemplates = {};
	                for (var s = 0; s < children.length; s++) {
	                    if (children[s].getAttribute !== undefined) {
	                        if (utils.hasAttr(children[s], 'data-template-for') && children[s].getAttribute('data-template-for').length > 0 && this.nestedItem === children[s].getAttribute('data-template-for') && !foundTemplates[this.nestedItem]) {
	                            // Nested template
	                            this.createTemplate(children[s]);
	                            // Guards against recursion when child template has same name!
	                            foundTemplates[this.nestedItem] = true;
	                        } else if (utils.hasAttr(children[s], 'data-template') && !utils.isNested(children[s])) {
	                            // Normal template
	                            this.createTemplate(children[s]);
	                        }
	                    }
	                }
	
	                // If there is no default template (data-template) then create one from container
	                //                if (this.defaultTemplate === null) {
	                //                    this.createTemplate(container);
	                //                }
	
	                utils.clearContainer(this.container);
	                if (callback !== undefined) {
	                    callback(this);
	                }
	            }
	        },
	
	        createTemplate: function createTemplate(node) {
	            var element = node.cloneNode(true);
	
	            // Clear display: none;
	            if (element.style.removeAttribute) {
	                element.style.removeAttribute('display');
	            } else if (element.style.removeProperty) {
	                element.style.removeProperty('display');
	            } else {
	                element.style.display = 'block';
	            }
	
	            // Remapping container element in case template
	            // is deep in container
	            this.container = node.parentNode;
	
	            // Element is a template
	            var nonDefault = false;
	            for (var a = 0; a < element.attributes.length; a++) {
	                var attr = element.attributes[a];
	                // If attribute
	                if (utils.startsWith(attr.name, 'data-if-')) {
	                    var val;
	                    if (attr.value === '') {
	                        val = true;
	                    } else if (attr.value === 'null') {
	                        val = null;
	                    } else {
	                        val = '\'' + attr.value + '\'';
	                    }
	                    this.namedTemplates[attr.name.substring(8, attr.name.length) + '==' + val] = element;
	                    utils.removeAttr(element, attr.name);
	                    nonDefault = true;
	                } else if (attr.name === 'data-has') {
	                    this.namedTemplates[attr.value + '!==undefined'] = element;
	                    utils.removeAttr(element, attr.name);
	                    nonDefault = true;
	                } else if (attr.name === 'data-from-map') {
	                    this.dataIsMap = true;
	                } else if (!utils.startsWith(attr.name, 'data-template') && utils.startsWith(attr.name, 'data-')) {
	                    // Treat as an attribute for template
	                    this.attributes[attr.name.substring(5, attr.name.length)] = attr.value;
	                }
	            }
	            // Setting as default template, last one wins
	            if (!nonDefault) {
	                this.defaultTemplate = element;
	            }
	        },
	
	        templateFor: function templateFor(i) {
	            for (var templateName in this.namedTemplates) {
	                if (eval('i.' + templateName)) {
	                    return this.namedTemplates[templateName].cloneNode(true);
	                }
	            }
	            if (this.defaultTemplate) {
	                return this.defaultTemplate.cloneNode(true);
	            }
	        }
	    };
	
	    /*!
	     * Renderer for populating containers with data using templates.
	     */
	    function Renderer(templates) {
	        this.templates = templates;
	        this.listener = [];
	        this.started = false;
	        this.varRegex = new RegExp(this.templates.var_brace_left + '[ ]?([A-Za-z0-9$\\._\\[\\]]*?)([ ]?\\|[ ]?.*?)?[ ]?' + this.templates.var_brace_right, 'g');
	        this.tagRegex = new RegExp(this.templates.tag_brace_left + '[ ]?([\\s\\S]*?)( [\\s\\S]*?)?[ ]?' + this.templates.tag_brace_right + '(([\\s\\S]*?)(?=' + this.templates.tag_brace_left + '[ ]?end\\1[ ]?' + this.templates.tag_brace_right + '))?', 'g');
	        this.filterSplitter = new RegExp('\\|[ ]?(?=' + utils.memberRegex(this.filters) + ')', 'g');
	        this.errorHandler = null;
	        return this;
	    }
	
	    Renderer.prototype = {
	        when: function when(type, listener) {
	            this.listener.push({ 'type': type, 'listener': listener });
	
	            return this;
	        },
	
	        _getValue: function _getValue(renderer, variable, i, t) {
	            var val = null;
	            // Handling tempo_info variable
	            if (utils.startsWith(variable, '_tempo.')) {
	                return eval('t.' + variable.substring(7, variable.length));
	            }
	
	            if (variable === '.') {
	                val = eval('i');
	            } else if (variable === 'this' || variable.match(/this[\\[\\.]/) !== null) {
	                val = eval('i' + variable.substring(4, variable.length));
	            } else if (utils.typeOf(i) === 'array') {
	                val = eval('i' + variable);
	            } else {
	                val = eval('i.' + variable);
	            }
	
	            return val;
	        },
	
	        _replaceVariables: function _replaceVariables(renderer, _tempo, i, str) {
	            var self = this;
	            return str.replace(this.varRegex, function (match, variable, args) {
	
	                try {
	                    var val = renderer._getValue(renderer, variable, i, _tempo);
	                    // Handle filters
	                    if (args !== undefined && args !== '') {
	                        var filters = utils.trim(utils.trim(args).substring(1)).split(self.filterSplitter);
	                        for (var p = 0; p < filters.length; p++) {
	                            var filter = utils.trim(filters[p]),
	                                filter_args,
	                                j = filter.indexOf(' ');
	                            // If there is a space, there must be arguments
	                            if (~j) {
	                                filter_args = filter.substr(j).replace(/(^ *['"])|(['"] *$)/g, '').split(/['"] *, *['"]/);
	                                filter = filter.substr(0, j);
	                            } else {
	                                filter_args = [];
	                            }
	                            val = renderer.filters[filter](val, filter_args);
	                        }
	                    }
	
	                    if (val !== undefined) {
	                        if (self.templates.escape) {
	                            val = self.filters.escape(val, {});
	                        }
	                        return val;
	                    }
	                } catch (err) {
	                    self._onError.call(self, err);
	                }
	
	                return '';
	            });
	        },
	
	        _replaceObjects: function _replaceObjects(renderer, _tempo, i, str, regex) {
	            return str.replace(regex, function (match, variable, args) {
	                try {
	                    var val = renderer._getValue(renderer, variable, i, _tempo);
	
	                    if (val !== undefined) {
	                        if (utils.typeOf(val) === 'string') {
	                            return '\'' + val + '\'';
	                        } else {
	                            return val;
	                        }
	                    }
	                } catch (err) {
	                    self._onError.call(self, err);
	                }
	
	                return undefined;
	            });
	        },
	
	        _applyAttributeSetters: function _applyAttributeSetters(renderer, item, str) {
	            // Adding a space in front of first part to make sure I don't get partial matches
	            return str.replace(/(\b[A-z0-9]+?)(?:="[^"']*?"[^>]*?)data-\1="(.*?)"/g, function (match, attr, data_value) {
	                if (data_value !== '') {
	                    return attr + '="' + data_value + '"';
	                }
	                return match;
	            });
	        },
	
	        _applyTags: function _applyTags(renderer, item, str) {
	            return str.replace(this.tagRegex, function (match, tag, args, body) {
	                if (renderer.tags.hasOwnProperty(tag)) {
	                    args = args.substring(args.indexOf(' ')).replace(/^[ ]*|[ ]*$/g, '');
	                    var filter_args = args.split(/(?:['"])[ ]?,[ ]?(?:['"])/);
	                    return renderer.tags[tag](renderer, item, match, filter_args, body);
	                } else {
	                    return '';
	                }
	            });
	        },
	
	        starting: function starting(event) {
	            // Use this to manually fire the RENDER_STARTING event e.g. just before you issue an AJAX request
	            // Useful if you're not calling prepare immediately before render
	            this.started = true;
	            if (event === undefined) {
	                event = new TempoEvent(TempoEvent.Types.RENDER_STARTING, undefined, undefined);
	            }
	            utils.notify(this.listener, event);
	
	            return this;
	        },
	
	        _renderNestedItem: function _renderNestedItem(i, nested) {
	            var self = this;
	            return function (templates) {
	                var r = new Renderer(templates);
	                var data = null;
	
	                if (nested === '*' || i.hasOwnProperty(nested.split('.')[0])) {
	                    if (nested === '*') {
	                        data = i;
	                    } else {
	                        data = eval('i.' + nested);
	                    }
	
	                    if (data) {
	                        try {
	                            if (utils.typeOf(data) === 'array') {
	                                for (var s = 0; s < data.length; s++) {
	                                    if (utils.typeOf(data[s]) === 'object') {
	                                        data[s]._parent = function () {
	                                            return i;
	                                        }();
	                                    }
	                                }
	                            } else {
	                                data._parent = function () {
	                                    return i;
	                                }();
	                            }
	                        } catch (err) {
	                            self._onError.call(self, err);
	                        }
	                    }
	                }
	                r.render(data);
	            };
	        },
	
	        renderItem: function renderItem(renderer, _tempo_info, i, fragment) {
	            var memberRegex = new RegExp('(?:__[\\.]?)((_tempo|\\[|' + utils.memberRegex(i) + '|this)([A-Za-z0-9$\\._\\[\\]]+)?)', 'g');
	            var template = renderer.templates.templateFor(i);
	            var tempo_info = utils.merge(_tempo_info, renderer.templates.attributes);
	
	            // Clear attributes in case of recursive nesting (TODO: Probably need to clear more)
	            if (utils.hasAttr(template, 'data-template-for')) {
	                utils.removeAttr(template, 'data-template-for');
	            }
	            if (utils.hasAttr(template, 'data-template-file')) {
	                utils.removeAttr(template, 'data-template-file');
	            }
	
	            if (template && i) {
	                utils.notify(this.listener, new TempoEvent(TempoEvent.Types.ITEM_RENDER_STARTING, i, template));
	                var nestedDeclaration = template.innerHTML.match(/data-template-for="([^"]+?)"/g);
	                if (nestedDeclaration) {
	                    for (var p = 0; p < nestedDeclaration.length; p++) {
	                        var nested = nestedDeclaration[p].match(/data-template-for="([^"]+?)"/);
	                        if (nested && nested[1]) {
	                            var t = new Templates(renderer.templates.params, nested[1]);
	                            try {
	                                t.parse(template, this._renderNestedItem(i, nested[1]));
	                            } catch (err) {
	                                this._onError.call(this, err);
	                            }
	                        }
	                    }
	                }
	
	                // Processing template element attributes
	                for (var a = 0; a < template.attributes.length; a++) {
	                    var attr = template.attributes[a];
	                    if (attr !== null && attr.specified && attr.value !== null && attr.value.length > 0 && attr.name.match(/style|data-template.*/) === null) {
	                        attr.value = this._applyTags(this, i, attr.value);
	                        attr.value = this._replaceVariables(this, tempo_info, i, attr.value);
	                    }
	                }
	
	                // Dealing with HTML as a String from now on (to be reviewed)
	                // Attribute values are escaped in FireFox so making sure there are no escaped tags
	                var html = template.innerHTML.replace(/%7B%7B/g, '{{').replace(/%7D%7D/g, '}}');
	
	                // Tags
	                html = this._applyTags(this, i, html);
	
	                // Content
	                html = this._replaceVariables(this, tempo_info, i, html);
	
	                // JavaScript objects
	                html = this._replaceObjects(this, tempo_info, i, html, memberRegex);
	
	                html = this._applyAttributeSetters(this, i, html);
	
	                fragment.appendChild(utils.getElement(template, html));
	
	                utils.notify(this.listener, new TempoEvent(TempoEvent.Types.ITEM_RENDER_COMPLETE, i, template));
	            }
	        },
	
	        _createFragment: function _createFragment(data) {
	            if (data) {
	                var tempo_info = {};
	                var fragment = _window.document.createDocumentFragment();
	
	                // If object then wrapping in an array
	                if (utils.typeOf(data) === 'object') {
	                    if (this.templates.dataIsMap) {
	                        var mapped = [];
	                        for (var member in data) {
	                            if (data.hasOwnProperty(member) && member !== '_parent') {
	                                var pair = {};
	                                pair.key = member;
	                                pair.value = data[member];
	                                mapped.push(pair);
	                            }
	                        }
	                        data = mapped;
	                    } else {
	                        data = [data];
	                    }
	                }
	
	                for (var i = 0; i < data.length; i++) {
	                    tempo_info.index = i;
	                    tempo_info.first = i < 1;
	                    tempo_info.last = i == data.length - 1;
	                    this.renderItem(this, tempo_info, data[i], fragment);
	                }
	
	                return fragment;
	            }
	
	            return null;
	        },
	
	        into: function into(target) {
	            if (target !== undefined) {
	                this.templates.container = utils.container(target);
	            }
	
	            return this;
	        },
	
	        render: function render(data) {
	            // Check if starting event was manually fired
	            if (!this.started) {
	                this.starting(new TempoEvent(TempoEvent.Types.RENDER_STARTING, data, this.templates.container));
	            }
	
	            this.clear();
	            this.append(data);
	
	            return this;
	        },
	
	        append: function append(data) {
	            // Check if starting event was manually fired
	            if (!this.started) {
	                this.starting(new TempoEvent(TempoEvent.Types.RENDER_STARTING, data, this.templates.container));
	            }
	
	            var fragment = this._createFragment(data);
	            if (fragment !== null && this.templates.container !== null) {
	                if (fragment !== null) {
	                    var ref = null;
	                    for (var i = this.templates.container.childNodes.length; i >= 0; i--) {
	
	                        if (this.templates.container.childNodes[i] !== undefined && this.templates.container.childNodes[i].getAttribute !== undefined && this.templates.container.childNodes[i].getAttribute('data-after-template') !== null) {
	                            ref = this.templates.container.childNodes[i];
	                        }
	                    }
	                    if (ref === null) {
	                        ref = this.templates.container.lastChild;
	                    }
	                    if (ref !== null) {
	                        this.templates.container.insertBefore(fragment, ref);
	                    } else {
	                        this.templates.container.appendChild(fragment);
	                    }
	                }
	            }
	
	            utils.notify(this.listener, new TempoEvent(TempoEvent.Types.RENDER_COMPLETE, data, this.templates.container));
	
	            return this;
	        },
	
	        prepend: function prepend(data) {
	            // Check if starting event was manually fired
	            if (!this.started) {
	                this.starting(new TempoEvent(TempoEvent.Types.RENDER_STARTING, data, this.templates.container));
	            }
	
	            var fragment = this._createFragment(data);
	            if (fragment !== null) {
	                var ref = null;
	                for (var i = 0; i < this.templates.container.childNodes.length; i++) {
	                    if (this.templates.container.childNodes[i] !== undefined && this.templates.container.childNodes[i].getAttribute !== undefined && this.templates.container.childNodes[i].getAttribute('data-before-template') !== null) {
	                        ref = this.templates.container.childNodes[i];
	                    }
	                }
	                if (ref === null) {
	                    ref = this.templates.container.firstChild;
	                }
	                if (ref !== null) {
	                    if (ref.nextSibling !== null && ref.getAttribute && ref.getAttribute('data-before-template') !== null) {
	                        ref = ref.nextSibling;
	                    }
	                    this.templates.container.insertBefore(fragment, ref);
	                } else {
	                    this.templates.container.appendChild(fragment);
	                }
	            }
	
	            utils.notify(this.listener, new TempoEvent(TempoEvent.Types.RENDER_COMPLETE, data, this.templates.container));
	
	            return this;
	        },
	
	        errors: function errors(errorHandler) {
	            this.errorHandler = errorHandler;
	            return this;
	        },
	
	        _onError: function _onError(err) {
	            if (this.errorHandler !== null) {
	                this.errorHandler.call(this, err);
	            }
	        },
	
	        clear: function clear() {
	            utils.notify(this.listener, new TempoEvent(TempoEvent.Types.BEFORE_CLEAR, {}, this.templates.container));
	            utils.clearContainer(this.templates.container);
	            utils.notify(this.listener, new TempoEvent(TempoEvent.Types.AFTER_CLEAR, {}, this.templates.container));
	        },
	
	        tags: {
	            'if': function _if(renderer, i, match, args, body) {
	                var member_regex = utils.memberRegex(i);
	
	                var expr = args[0].replace(/&amp;/g, '&').replace(/&gt;/g, '>').replace(/&lt;/g, '<');
	                expr = expr.replace(new RegExp(member_regex, 'gi'), function (match) {
	                    return 'i.' + match;
	                });
	
	                var blockRegex = new RegExp(renderer.templates.tag_brace_left + '[ ]?else[ ]?' + renderer.templates.tag_brace_right, 'g');
	                var blocks = body.split(blockRegex);
	
	                if (eval(expr)) {
	                    return blocks[0];
	                } else if (blocks.length > 1) {
	                    return blocks[1];
	                }
	
	                return '';
	            }
	        },
	
	        filters: {
	            'escape': function escape(value, args) {
	                return value.toString().replace(/[&<>]/g, function (c) {
	                    return {
	                        '&': '&amp;',
	                        '<': '&lt;',
	                        '>': '&gt;'
	                    }[c] || c;
	                });
	            },
	            'encodeURI': function (_encodeURI) {
	                function encodeURI(_x, _x2) {
	                    return _encodeURI.apply(this, arguments);
	                }
	
	                encodeURI.toString = function () {
	                    return _encodeURI.toString();
	                };
	
	                return encodeURI;
	            }(function (value, args) {
	                return encodeURI(value.toString());
	            }),
	            'decodeURI': function (_decodeURI) {
	                function decodeURI(_x3, _x4) {
	                    return _decodeURI.apply(this, arguments);
	                }
	
	                decodeURI.toString = function () {
	                    return _decodeURI.toString();
	                };
	
	                return decodeURI;
	            }(function (value, args) {
	                return decodeURI(value.toString());
	            }),
	            'truncate': function truncate(value, args) {
	                if (value !== undefined) {
	                    var len = 0;
	                    var rep = '...';
	                    if (args.length > 0) {
	                        len = parseInt(args[0], 10);
	                    }
	                    if (args.length > 1) {
	                        rep = args[1];
	                    }
	                    if (value.length > len - 3) {
	                        return value.substr(0, len - 3) + rep;
	                    }
	                    return value;
	                }
	            },
	            'format': function format(value, args) {
	                if (value !== undefined) {
	                    if (args.length === 1) {
	                        value = parseFloat(value + '').toFixed(parseInt(args[0], 10));
	                    }
	                    var x = (value + '').split('.');
	                    var x1 = x[0];
	                    var x2 = x.length > 1 ? '.' + x[1] : '';
	
	                    while (NUMBER_FORMAT_REGEX.test(x1)) {
	                        x1 = x1.replace(NUMBER_FORMAT_REGEX, '$1' + ',' + '$2');
	                    }
	
	                    return x1 + x2;
	                }
	            },
	            'upper': function upper(value, args) {
	                return value.toUpperCase();
	            },
	            'lower': function lower(value, args) {
	                return value.toLowerCase();
	            },
	            'titlecase': function titlecase(value, args) {
	                var blacklist = [];
	                if (args !== undefined && args.length === 1) {
	                    blacklist = args[0].split(' ');
	                }
	                return value.replace(/\w[a-z]\S*/g, function (m, i) {
	                    if (blacklist.length === 0 || !(utils.arrayContains(blacklist, m) && i > 0)) {
	                        return m.charAt(0).toUpperCase() + m.substr(1).toLowerCase();
	                    }
	                    return m;
	                });
	            },
	            'trim': function trim(value, args) {
	                return utils.trim(value);
	            },
	            'replace': function replace(value, args) {
	                if (value !== undefined && args.length === 2) {
	                    return value.replace(new RegExp(args[0], 'g'), args[1]);
	                }
	                return value;
	            },
	            'append': function append(value, args) {
	                if (value !== undefined && args.length === 1) {
	                    return value + '' + args[0];
	                }
	                return value;
	            },
	            'prepend': function prepend(value, args) {
	                if (value !== undefined && args.length === 1) {
	                    return args[0] + '' + value;
	                }
	                return value;
	            },
	            'join': function join(value, args) {
	                if (args.length === 1 && value !== undefined && utils.typeOf(value) === 'array') {
	                    return value.join(args[0]);
	                }
	                return value;
	            },
	            'default': function _default(value, args) {
	                if (value !== undefined && value !== null) {
	                    return value;
	                }
	                if (args.length === 1) {
	                    return args[0];
	                }
	                return value;
	            },
	            'date': function date(value, args) {
	                if (value !== undefined && args.length >= 1 && args.length <= 2) {
	                    var date = new Date(value);
	                    var format = args[0];
	                    var isUTC = args.length === 2 && args[1] === 'UTC';
	                    if (format === 'localedate') {
	                        return date.toLocaleDateString();
	                    } else if (format === 'localetime') {
	                        return date.toLocaleTimeString();
	                    } else if (format === 'date') {
	                        return date.toDateString();
	                    } else if (format === 'time') {
	                        return date.toTimeString();
	                    } else {
	                        var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	                        var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
	                        var DATE_PATTERNS = {
	                            'YYYY': function YYYY(date) {
	                                return isUTC ? date.getUTCFullYear() : date.getFullYear();
	                            },
	                            'YY': function YY(date) {
	                                return (isUTC ? date.getUTCFullYear() : date.getFullYear()).toFixed().substring(2);
	                            },
	                            'MMMM': function MMMM(date) {
	                                return MONTHS[isUTC ? date.getUTCMonth() : date.getMonth()];
	                            },
	                            'MMM': function MMM(date) {
	                                return MONTHS[isUTC ? date.getUTCMonth() : date.getMonth()].substring(0, 3);
	                            },
	                            'MM': function MM(date) {
	                                return utils.pad(((isUTC ? date.getUTCMonth() : date.getMonth()) + 1).toFixed(), '0', 2);
	                            },
	                            'M': function M(date) {
	                                return (isUTC ? date.getUTCMonth() : date.getMonth()) + 1;
	                            },
	                            'DD': function DD(date) {
	                                return utils.pad((isUTC ? date.getUTCDate() : date.getDate()).toFixed(), '0', 2);
	                            },
	                            'D': function D(date) {
	                                return isUTC ? date.getUTCDate() : date.getDate();
	                            },
	                            'EEEE': function EEEE(date) {
	                                return DAYS[isUTC ? date.getUTCDay() : date.getDay()];
	                            },
	                            'EEE': function EEE(date) {
	                                return DAYS[isUTC ? date.getUTCDay() : date.getDay()].substring(0, 3);
	                            },
	                            'E': function E(date) {
	                                return isUTC ? date.getUTCDay() : date.getDay();
	                            },
	                            'HH': function HH(date) {
	                                return utils.pad((isUTC ? date.getUTCHours() : date.getHours()).toFixed(), '0', 2);
	                            },
	                            'H': function H(date) {
	                                return isUTC ? date.getUTCHours() : date.getHours();
	                            },
	                            'h': function h(date) {
	                                var hours = isUTC ? date.getUTCHours() : date.getHours();
	                                return hours < 13 ? hours === 0 ? 12 : hours : hours - 12;
	                            },
	                            'mm': function mm(date) {
	                                return utils.pad((isUTC ? date.getUTCMinutes() : date.getMinutes()).toFixed(), '0', 2);
	                            },
	                            'm': function m(date) {
	                                return isUTC ? date.getUTCMinutes() : date.getMinutes();
	                            },
	                            'ss': function ss(date) {
	                                return utils.pad((isUTC ? date.getUTCSeconds() : date.getSeconds()).toFixed(), '0', 2);
	                            },
	                            's': function s(date) {
	                                return isUTC ? date.getUTCSeconds() : date.getSeconds();
	                            },
	                            'SSS': function SSS(date) {
	                                return utils.pad((isUTC ? date.getUTCMilliseconds() : date.getMilliseconds()).toFixed(), '0', 3);
	                            },
	                            'S': function S(date) {
	                                return isUTC ? date.getUTCMilliseconds() : date.getMilliseconds();
	                            },
	                            'a': function a(date) {
	                                return (isUTC ? date.getUTCHours() : date.getHours()) < 12 ? 'AM' : 'PM';
	                            }
	                        };
	                        format = format.replace(/(\\)?(Y{2,4}|M{1,4}|D{1,2}|E{1,4}|H{1,2}|h|m{1,2}|s{1,2}|S{1,3}|a)/g, function (match, escape, pattern) {
	                            if (!escape) {
	                                if (DATE_PATTERNS.hasOwnProperty(pattern)) {
	                                    return DATE_PATTERNS[pattern](date);
	                                }
	                            }
	                            return pattern;
	                        });
	
	                        return format;
	                    }
	                }
	
	                return '';
	            }
	        }
	    };
	
	    /*!
	     * Initialising Tempo with a Window object in case running inside Node.
	     */
	    tempo.init = function (window) {
	        _window = window;
	        return this;
	    };
	
	    /*!
	     * Prepare a container for rendering, gathering templates and
	     * clearing afterwards.
	     */
	    tempo.prepare = function (container, params, callback) {
	        container = utils.container(container);
	
	        var templates = new Templates(params);
	        if (callback !== undefined) {
	            templates.parse(container, function (templates) {
	                callback(new Renderer(templates));
	            });
	        } else {
	            templates.parse(container);
	            return new Renderer(templates);
	        }
	    };
	
	    tempo.exports = {
	        'templates': Templates,
	        'utils': utils
	    };
	
	    tempo.test = {
	        'utils': utils,
	        'templates': new Templates({}),
	        'renderer': new Renderer(new Templates({}))
	    };
	
	    // Default initialisation
	    try {
	        tempo.init(window);
	    } catch (e) {
	        exports.tempo = tempo;
	    }
	
	    return tempo;
	}(Tempo || {});
	
	exports.default = Tempo;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// NOTE: aquí hay un ejemplo [http://athletic.elcorreo.com/noticias/201703/12/real-sociedad-athletic-directo-20170306121619.html?op=cscribble]
	
	var CONFIG_NAMESPACE = exports.CONFIG_NAMESPACE = 'vocento.config.scribblelive';
	var DEFAULT_TEMPLATE = exports.DEFAULT_TEMPLATE = 'widget';
	
	var DEFAULTS = exports.DEFAULTS = Object.freeze({
	  APIToken: 'CFhft3e',
	  escribeCapaJs: true, // true -> use template, false -> use IframeApi with embedded template
	  ColumnLocation: 'C',
	  avatar1: false,
	  avatar2: false,
	  avatar3: false,
	  avatar4: false,
	  SL_valor_epigrafe: 'Última hora',
	  SL_url_epigrafe: null,
	  Scribble_tipoEspecial: '', // Se utiliza para cambiar algunos aspetos de presentación('elecciones-2015' | 'nuevo')
	  SL_valor_numeroMensajesPagina: 40,
	  SL_valor_evento1Titulo: 'Directo',
	  SL_valor_evento1URLPaginaDetalle: null,
	  SL_valor_evento2ID: null,
	  SL_valor_evento2Titulo: null,
	  SL_valor_evento2URLPaginaDetalle: null,
	  SL_valor_evento3ID: null,
	  SL_valor_evento3Titulo: null,
	  SL_valor_evento3URLPaginaDetalle: null,
	  SL_valor_evento4ID: null,
	  SL_valor_evento4Titulo: null,
	  SL_valor_evento4URLPaginaDetalle: null,
	  SL_valor_plantilla: '1998',
	  Scribble_ancho: undefined, // by default 300
	  Scribble_alto: undefined, // by default 450
	  Scribble_pageElementId: 'SL_eventoNoticia', // place where comments will be displayed, by default SL_evento
	  Scribble_template_twitter: null,
	  Scribble_dateFormat: null, // by default DD/MM/YYYY HH:mm:ss
	  Scribble_todayDateFormat: null, // by default HH:mm:ss
	  Scribble_Iframe_API: '//embed.scribblelive.com/Embed/v5.aspx',
	  Scribble_API: '//apiv1.scribblelive.com',
	  relativeTimeLanguage: 'es'
	});

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = "<div data-template> <span class=voc-live-time>{{FormattedDate}}</span> <span class=voc-live-author>{{Creator.Name}}</span> <p> {% if Link %} <a href={{Link}}>{{Content}}</a> {% else %} <a>{{Content}}</a> {% endif %} </p> </div> ";

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	module.exports = "<div data-template> <div class=voc-live-scribble-item> <div class=voc-live-scribble-author> {% if Creator.Avatar.length > 0 %} <img src={{Creator.Avatar}} class=figure-author alt=\"\"> {% endif %} {% if Creator.Avatar.length == 0 %} <i class=\"voc-services nothing\"></i> {% endif %} </div> <p class=voc-live-scribble-date>{{FormattedDate}}</p> <div class=voc-live-scribble-content> <p class=author-name>{{Creator.Name}}</p> <p class=voc-description>{{Content}}</p> </div> </div> </div> ";

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// scribble-live.js